<template>
  <div class="map-wrapper">
    <!-- 선택된 섬네일 이미지의 RGB이미지를 맵에 보여줄때 사용하기 위한 선택버튼 -->

    <!-- <v-switch
      class="switch"
      v-model="visibleImageOnMap"
      :label="$t('map.rgb_image')"
      color="primary"
      dense
      inset
      hide-details
    ></v-switch> -->

    <div id="map">
      <div v-show="getMapMenu" class="map-left-overlay-tools">
        <div v-show="thermalImage !== ''" class="mini-img toolbarmap_color map-toolbar-tool-block">
          <v-tooltip
            bottom
            :disabled="thermalTemperatureStatsStatus !== 'unavailable'"
            :z-index="2000"
          >
            <template slot="activator" slot-scope="{ on: tooltipOn }">
              <v-menu
                v-model="thermalIrMenuOpen"
                bottom
                :close-on-click="closeOnClick"
                :close-on-content-click="false"
              >
                <template slot="activator" slot-scope="{ on: menuOn }">
                  <v-badge
                    overlap
                    dot
                    :value="thermalTemperatureStatsStatus === 'unavailable'"
                    color="warning"
                  >
                    <v-btn
                      :class="{
                        'map-toolbar-interactive-btn': true,
                        'map-toolbar-thermal-btn': true,
                        'map-toolbar-tool-btn--stack': true
                      }"
                      color="surface"
                      elevation="1"
                      v-on="{ ...menuOn, ...tooltipOn }"
                    >
                      <span
                        class="map-toolbar-tool-btn__inner d-flex flex-column align-center map-toolbar-tool-btn__inner--gap-relaxed"
                      >
                        <span class="map-toolbar-tool-icon map-toolbar-tool-icon--sm">
                          <v-icon
                            :color="mapToolbarToggleIconIdle"
                            class="map-toolbar-mdi-icon map-toolbar-thermal-btn__icon"
                          >
                            mdi-thermometer
                          </v-icon>
                        </span>
                        <span class="map-toolbar-tool-label">{{
                          $t('map.toolbarCaptionThermal')
                        }}</span>
                      </span>
                    </v-btn>
                  </v-badge>
                </template>

                <v-card color="surface" class="thermal-ir-panel-card" elevation="2">
                  <v-card-title class="thermal-ir-panel-title px-3 py-2">
                    <div class="d-flex flex-column flex-grow-1 thermal-ir-panel-title-text min-width-0 mr-2">
                      <span class="text-subtitle-2 font-weight-medium text--primary text-truncate">
                        {{ $t('map.thermalPanelTitle') }}
                      </span>
                      <span
                        class="text-caption text--secondary text-truncate mt-0"
                        :title="thermalImage?.imgUrl ? selectedThermalImage?.imgName : ''"
                      >
                        {{
                          thermalImage?.imgUrl
                            ? selectedThermalImage?.imgName
                            : $t('map.pleaseSelectFile')
                        }}
                      </span>
                    </div>
                    <v-btn
                      icon
                      small
                      class="thermal-ir-panel-close flex-shrink-0"
                      :ripple="false"
                      :aria-label="$t('common.close')"
                      @click.stop="thermalIrMenuOpen = false"
                    >
                      <v-icon :color="mapToolbarToggleIconIdle" small>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-divider />
                  <!-- 가로 패딩은 래퍼에만 두고, 자식은 width:100%만 써서 mx+100% 오버플로(우측 잘림) 방지 -->
                  <div class="thermal-ir-panel-body px-2 pt-1 pb-1">
                    <div
                      v-if="
                        thermalTemperatureStatsStatus === 'loading' ||
                        thermalTemperatureStatsStatus === 'unavailable'
                      "
                      class="thermal-temp-status-banner"
                    >
                      <v-progress-linear
                        v-if="thermalTemperatureStatsStatus === 'loading'"
                        indeterminate
                        height="3"
                        color="primary"
                      />
                      <v-alert
                        v-else-if="thermalTemperatureStatsStatus === 'unavailable'"
                        dense
                        outlined
                        type="warning"
                        class="mb-0 thermal-temp-unavailable-alert"
                      >
                        {{ $t('map.thermalTempDataUnavailable') }}
                      </v-alert>
                    </div>
                    <div
                      v-if="thermalPreviewImgSrc"
                      ref="thermalPreviewWrap"
                      class="thermal-ir-preview-interactive mt-2"
                      @mouseleave="onThermalPreviewMouseLeave"
                    >
                      <v-img
                        class="hover mini-img-wrap thermal-ir-preview-img pa-0 ma-0"
                        :src="thermalPreviewImgSrc"
                        :width="thermalPreviewImgWpx + 'px'"
                        :height="thermalPreviewImgHpx + 'px'"
                        contain
                        :alt="$t('map.selectImagePrompt')"
                        @mousemove.native="displayDegree"
                      />
                      <div
                        v-show="
                          thermalHoverReadout.show && thermalTemperatureStatsStatus === 'ready'
                        "
                        class="thermal-hover-readout text-body-2 font-weight-medium"
                        :style="{
                          left: thermalHoverReadout.x + 'px',
                          top: thermalHoverReadout.y + 'px'
                        }"
                      >
                        {{ thermalPointLabel }}
                      </div>
                    </div>
                    <div
                      v-else
                      class="thermal-ir-preview-placeholder-box d-flex align-center justify-center mt-2"
                    >
                      <span
                        class="thermal-ir-preview-placeholder-text text-body-2 text--secondary text-center"
                        >{{ $t('map.selectImagePrompt') }}</span
                      >
                    </div>
                    <!-- 이미지와 동일 가로폭(px-3 기준) — v-card-text(pa-2)와 분리하면 통계 행만 더 넓게 보임 -->
                    <div
                      class="thermal-stats-compact thermal-stats-compact--under-preview pt-2 pb-2 mt-1"
                    >
                      <div
                        class="d-flex flex-wrap align-center justify-space-between thermal-stats-compact-row"
                      >
                        <span class="thermal-stats-compact-item d-flex align-center flex-shrink-0">
                          <v-icon small color="error">mdi-thermometer-high</v-icon>
                          <span class="text-caption text--secondary ml-1">{{
                            $t('map.thermalStatMax')
                          }}</span>
                          <span
                            class="thermal-stats-compact-value font-weight-medium thermal-stat-value--max ml-1"
                          >
                            {{ formatThermalStatValue(maxThermalValue) }}
                          </span>
                        </span>
                        <span class="thermal-stats-compact-item d-flex align-center flex-shrink-0">
                          <v-icon small color="info">mdi-thermometer-low</v-icon>
                          <span class="text-caption text--secondary ml-1">{{
                            $t('map.thermalStatMin')
                          }}</span>
                          <span
                            class="thermal-stats-compact-value font-weight-medium thermal-stat-value--min ml-1"
                          >
                            {{ formatThermalStatValue(minThermalValue) }}
                          </span>
                        </span>
                        <span class="thermal-stats-compact-item d-flex align-center flex-shrink-0">
                          <v-icon small color="success">mdi-chart-line</v-icon>
                          <span class="text-caption text--secondary ml-1">{{
                            $t('map.thermalStatAvg')
                          }}</span>
                          <span
                            class="thermal-stats-compact-value font-weight-medium thermal-stat-value--avg ml-1"
                          >
                            {{ formatThermalStatValue(averageThermalValue) }}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-menu>
            </template>
            <span>{{ $t('map.thermalToolbarTooltipNoTempData') }}</span>
          </v-tooltip>
        </div>
      </div>

      <div v-show="getMapMenu" class="map-right-top-cluster">
        <!-- 툴바 먼저 → 모듈은 우측 드로어 옆(맨 오른쪽) -->
        <div class="map-toolbar">
          <v-card>
            <v-toolbar id="toolbar_icon" class="toolbar_color map-toolbar-toolbar-row">
              <!-- 사용빈도 순: AI → 산출 → 결함 → 맵 → 도움말 (+ 우측 모듈) -->
              <div class="map-toolbar-group flex-shrink-0">
                <div class="map-toolbar-group-label">{{ $t('map.toolbarGroupAi') }}</div>
                <div class="map-toolbar-group-tools map-toolbar-ai-anchor">
                  <MapToolbarTooltipBlock
                    v-if="userProfile?.userRole == 'ADMIN'"
                    caption-spacing="tight"
                    icon-area-size="lg"
                    :caption="
                      isAIButtonActive
                        ? $t('map.toolbarCaptionAiOn')
                        : $t('map.toolbarCaptionAiOff')
                    "
                    :tooltip-text="
                      isAIButtonActive
                        ? $t('map.toolbarTooltipAiOn')
                        : $t('map.toolbarTooltipAiOff')
                    "
                    block-class="toolbarmap_color"
                    :active="isAIButtonActive"
                    :btn-props="aiToolbarBtnProps"
                    @click="toggleAIButton"
                  >
                    <img
                      :src="toolbarAiImgSrc"
                      :class="mapToolbarRasterClass(isAIButtonActive)"
                      width="36"
                      height="36"
                      alt=""
                    />
                  </MapToolbarTooltipBlock>
                  <v-menu
                    v-model="aiDedupMenuOpen"
                    bottom
                    offset-y
                    open-on-hover
                    :open-delay="80"
                    :close-delay="200"
                  >
                    <template slot="activator" slot-scope="{ on: aiDedupMenuOn }">
                      <MapToolbarTooltipBlock
                        caption-i18n-key="map.toolbarCaptionAiDuplicate"
                        tooltip-i18n-key="map.aiDuplicateRemoval"
                        :tooltip-props="{ disabled: true }"
                        :active="aiDedupToolbarActive"
                        :btn-props="mapToolbarPressedToggleBtnProps(aiDedupToolbarActive, { icon: true })"
                        v-on="aiDedupMenuOn"
                      >
                        <v-icon :color="mapToolbarToggleIconColor(aiDedupToolbarActive)"
                          >mdi-compare</v-icon
                        >
                      </MapToolbarTooltipBlock>
                    </template>
                    <v-list dense>
                      <v-list-item @click="aiDedupDialogOpen = true">
                        <v-list-item-content>
                          <v-list-item-title>{{ $t('map.aiDedupMenuAuto') }}</v-list-item-title>
                          <v-list-item-subtitle>{{ $t('map.aiDedupMenuAutoHint') }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="thermalImageComparisonDialogOpen = true">
                        <v-list-item-content>
                          <v-list-item-title>{{ $t('map.aiDedupMenuManual') }}</v-list-item-title>
                          <v-list-item-subtitle>{{ $t('map.aiDedupMenuManualHint') }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </div>
              <v-divider class="map-toolbar-divider mx-1" vertical />
              <div class="map-toolbar-group flex-shrink-0">
                <div class="map-toolbar-group-label">{{ $t('map.toolbarGroupReport') }}</div>
                <div class="map-toolbar-group-tools">
                  <MapToolbarTooltipBlock
                    caption-i18n-key="map.toolbarCaptionReport"
                    tooltip-i18n-key="common.reports"
                    :active="reportSummaryDialogOpen"
                    :btn-props="mapToolbarPressedToggleBtnProps(reportSummaryDialogOpen, {
                      icon: true,
                      disabled: getReport ? false : true,
                      loading: reportSummaryLoading
                    })"
                    @click="openReportSummaryDialog"
                  >
                    <img
                      class="map-toolbar-report-svg"
                      :src="toolbarReportSvgSrc"
                      width="36"
                      height="36"
                      alt=""
                    />
                  </MapToolbarTooltipBlock>
                  <MapToolbarTooltipBlock
                    caption-i18n-key="map.toolbarCaptionDefectReport"
                    tooltip-i18n-key="reportDetail.title"
                    :active="reportDetailDialogOpen"
                    :btn-props="mapToolbarPressedToggleBtnProps(reportDetailDialogOpen, {
                      icon: true,
                      disabled: getReport ? false : true,
                      loading: reportDetailLoading
                    })"
                    @click="openReportDetailDialog"
                  >
                    <v-icon :color="mapToolbarToggleIconColor(reportDetailDialogOpen)">
                      mdi-file-document-multiple-outline
                    </v-icon>
                  </MapToolbarTooltipBlock>
                  <MapToolbarTooltipBlock
                    caption-i18n-key="map.toolbarCaptionSummary"
                    tooltip-i18n-key="map.defectSummary"
                    :active="showDefectSummaryTable"
                    :btn-props="mapToolbarPressedToggleBtnProps(showDefectSummaryTable, { icon: true })"
                    @click="showDefectSummaryTable = !showDefectSummaryTable"
                  >
                    <img
                      :src="require('@/assets/image/sumarary.png')"
                      :class="mapToolbarRasterClass(showDefectSummaryTable)"
                      width="36"
                      height="36"
                      alt=""
                    />
                  </MapToolbarTooltipBlock>
                </div>
              </div>
              <v-divider class="map-toolbar-divider mx-1" vertical />
              <div class="map-toolbar-group flex-shrink-0">
                <div class="map-toolbar-group-label">{{ $t('map.toolbarGroupDefect') }}</div>
                <div class="map-toolbar-group-tools map-toolbar-marker-anchor">
                  <MapToolbarTooltipBlock
                    caption-spacing="relaxed"
                    icon-area-size="sm"
                    :caption="
                      markersWanted
                        ? $t('map.toolbarCaptionMarkerOn')
                        : $t('map.toolbarCaptionMarkerOff')
                    "
                    :tooltip-text="
                      markersWanted
                        ? $t('map.toolbarTooltipMarkerOn')
                        : $t('map.toolbarTooltipMarkerOff')
                    "
                    :active="markersWanted"
                    :btn-props="defectMarkerToolbarBtnProps"
                    @click.stop="toggleDefectMarkers"
                  >
                    <v-icon :color="mapToolbarToggleIconColor(markersWanted)">
                      mdi-map-marker-check
                    </v-icon>
                  </MapToolbarTooltipBlock>
                  <MapToolbarTooltipBlock
                    v-if="userProfile?.userRole == 'ADMIN' && defectLayerVisible"
                    block-class="toolbarmap_color"
                    caption-i18n-key="map.toolbarCaptionMarker"
                    tooltip-i18n-key="map.editMapMarker"
                    :active="editingMapFlag"
                    :btn-props="mapToolbarPressedToggleBtnProps(editingMapFlag, {
                      icon: true,
                      disabled: !mapEditable
                    })"
                    @click="editingMapFlag = !editingMapFlag"
                  >
                    <img
                      class="map-toolbar-map-marker-svg"
                      :src="toolbarMapMarkerSvgSrc"
                      width="36"
                      height="36"
                      alt=""
                    />
                  </MapToolbarTooltipBlock>
                  <MapToolbarTooltipBlock
                    block-class="toolbar_color"
                    caption-i18n-key="map.toolbarCaptionFilter"
                    :tooltip-text="defectFilterTooltipText"
                    :active="defectTypeSelectShow"
                    :btn-props="mapToolbarPressedToggleBtnProps(defectTypeSelectShow, {
                      icon: true,
                      disabled: getReport ? false : true
                    })"
                    @click="defectTypeSelectShow = !defectTypeSelectShow"
                  >
                    <v-badge
                      overlap
                      bordered
                      :content="defectFilterBadgeCount"
                      :value="defectFilterBadgeVisible"
                      color="warning"
                      class="map-toolbar-status-badge"
                    >
                      <v-icon :color="mapToolbarToggleIconColor(defectTypeSelectShow)">
                        mdi-filter-variant
                      </v-icon>
                    </v-badge>
                  </MapToolbarTooltipBlock>
                </div>
              </div>
              <v-divider class="map-toolbar-divider mx-1" vertical />
              <!-- 맵: RGB뷰 + 레이어 — 단독 보기 그룹 해소 -->
              <div class="map-toolbar-group flex-shrink-0">
                <div class="map-toolbar-group-label">{{ $t('map.toolbarGroupMap') }}</div>
                <div class="map-toolbar-group-tools map-toolbar-layer-anchor">
                  <MapToolbarTooltipBlock
                    caption-spacing="rgb-view"
                    icon-area-size="lg"
                    caption-i18n-key="map.toolbarCaptionRgbView"
                    :tooltip-props="{
                      value: tooltipVisible,
                      openOnClick: false,
                      openOnFocus: false,
                      openOnHover: isRgbHovered,
                      style: { position: 'relative' }
                    }"
                    :active="visibleImageOnMap"
                    :btn-props="mapToolbarPressedToggleBtnProps(visibleImageOnMap, {
                      icon: true,
                      loading: readRGBLoading,
                      style: { position: 'relative' }
                    })"
                    tooltip-i18n-key="imageTypes.viewRgb"
                    @mouseenter="handleMouseLeave"
                    @mouseleave="handleMouseEnter"
                    @click.stop="onRgbViewButtonClick"
                    @tooltip-input="tooltipVisible = $event"
                  >
                    <img
                      :src="toolbarRgbImgSrc"
                      :class="mapToolbarRasterClass(visibleImageOnMap)"
                      width="36"
                      height="36"
                      alt=""
                    />
                  </MapToolbarTooltipBlock>
                  <MapToolbarTooltipBlock
                    caption-spacing="relaxed"
                    icon-area-size="sm"
                    caption-i18n-key="map.toolbarCaptionRgb"
                    tooltip-i18n-key="map.rgbLayerAll"
                    :active="rgbLayerVisible"
                    :btn-props="mapToolbarPressedToggleBtnProps(rgbLayerVisible, { loading: rgbLayerLoading })"
                    @click.stop="toggleRgbLayer"
                  >
                    <v-icon :color="mapToolbarToggleIconColor(rgbLayerVisible)">mdi-layers</v-icon>
                  </MapToolbarTooltipBlock>
                  <MapToolbarTooltipBlock
                    caption-spacing="relaxed"
                    icon-area-size="sm"
                    caption-i18n-key="map.toolbarCaptionIr"
                    tooltip-i18n-key="map.thermalLayerAll"
                    :active="irLayerVisible"
                    :btn-props="mapToolbarPressedToggleBtnProps(irLayerVisible, { loading: irLayerLoading })"
                    @click.stop="toggleIrLayer"
                  >
                    <v-icon :color="mapToolbarToggleIconColor(irLayerVisible)">mdi-layers</v-icon>
                  </MapToolbarTooltipBlock>
                  <MapToolbarTooltipBlock
                    caption-spacing="relaxed"
                    icon-area-size="sm"
                    caption-i18n-key="map.toolbarCaptionGeoJson"
                    tooltip-i18n-key="map.loadGeoJsonLayer"
                    :btn-props="mapToolbarPressedToggleBtnProps(false)"
                    @click.stop="openGeoJsonFileDialog"
                  >
                    <v-icon :color="mapToolbarToggleIconIdle">mdi-layers</v-icon>
                  </MapToolbarTooltipBlock>
                </div>
              </div>
              <v-divider class="map-toolbar-divider mx-1" vertical />
              <!-- 도움말: 레이어와 분리 (끝단) -->
              <div class="map-toolbar-group flex-shrink-0">
                <div class="map-toolbar-group-label map-toolbar-group-label--spacer" aria-hidden="true">
                  &nbsp;
                </div>
                <div class="map-toolbar-group-tools">
                  <MapToolbarTooltipBlock
                    caption-i18n-key="map.toolbarCaptionHelp"
                    tooltip-i18n-key="map.toolbarHelpTooltip"
                    :btn-props="mapToolbarPressedToggleBtnProps(false, { icon: true })"
                    @click="helpDialogOpen = true"
                  >
                    <v-icon :color="mapToolbarToggleIconIdle">mdi-help-circle-outline</v-icon>
                  </MapToolbarTooltipBlock>
                </div>
              </div>
            </v-toolbar>
            <v-card v-show="getMapMenu && showDefectSummaryTable" class="defect-summary-card">
              <v-expand-transition>
                <v-simple-table class="defect-summary-table">
                  <template slot="default">
                    <thead>
                      <tr>
                        <th class="text-left">
                          {{ $t('map.summaryIcon') }}
                        </th>
                        <th class="text-left">
                          {{ $t('map.summaryDefectName') }}
                        </th>
                        <th class="text-right">
                          {{ $t('map.summaryCount') }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in examineDefectSummaries" :key="item.defectCode">
                        <td>
                          <img
                            class="defect-sumary-icon"
                            :src="imageSrc(item.defectCode)"
                            alt="icon"
                            style="max-height: 35px; max-width: 35px"
                          />
                        </td>
                        <td>{{ item.defectName }}</td>
                        <td>{{ item.defectCount }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-expand-transition>
            </v-card>

          <!-- 지도 사용 도움말 다이얼로그 -->
          <v-dialog v-model="helpDialogOpen" max-width="520" scrollable>
            <v-card>
              <v-card-title
                class="text-subtitle-1 font-weight-medium d-flex align-center map-help-dialog-title"
              >
                <span class="d-flex align-center">
                  <v-icon small class="mr-2">mdi-help-circle-outline</v-icon>
                  지도 사용 도움말
                </span>
                <v-spacer />
                <v-btn
                  icon
                  small
                  :aria-label="$t('common.close')"
                  @click="helpDialogOpen = false"
                >
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text class="text-body-2 pt-2 map-help-dialog-body">
                <div class="font-weight-bold mb-1 map-help-section-title">기본 조작</div>
                <ul class="map-help-basic-list mb-3">
                  <li class="d-flex align-start mb-1">
                    <v-icon x-small class="map-help-basic-icon mt-1">mdi-magnify-plus-outline</v-icon>
                    <span><strong>마우스 휠</strong> — 확대 / 축소</span>
                  </li>
                  <li class="d-flex align-start mb-1">
                    <v-icon x-small class="map-help-basic-icon mt-1">mdi-cursor-move</v-icon>
                    <span><strong>드래그</strong> — 지도 이동</span>
                  </li>
                  <li class="d-flex align-start mb-1">
                    <v-icon x-small class="map-help-basic-icon mt-1">mdi-rotate-right</v-icon>
                    <span><strong>Alt + Shift + 드래그</strong> — 지도 회전</span>
                  </li>
                  <li class="d-flex align-start mb-1">
                    <v-icon x-small class="map-help-basic-icon mt-1">mdi-selection-drag</v-icon>
                    <span><strong>Shift + 드래그</strong> — 영역 확대</span>
                  </li>
                  <li class="d-flex align-start mb-1">
                    <v-icon x-small class="map-help-basic-icon mt-1">mdi-map-marker</v-icon>
                    <span><strong>우클릭</strong> — 해당 위치 좌표 복사</span>
                  </li>
                </ul>

                <div class="font-weight-bold mb-1 map-help-section-title">
                  좌측 오버레이 (지도 왼쪽)
                </div>
                <table class="map-help-table mb-3">
                  <tr>
                    <td class="map-help-tool-cell">
                      <span class="map-help-tool-chip">
                        <v-icon small :color="mapToolbarToggleIconIdle">mdi-thermometer</v-icon>
                        <span class="map-help-tool-caption">{{ $t('map.toolbarCaptionThermal') }}</span>
                      </span>
                    </td>
                    <td class="map-help-desc-cell">
                      열화상 미리보기 패널을 엽니다. 패널에서 열화상 이미지를 선택·확인할 수
                      있습니다.
                    </td>
                  </tr>
                </table>

                <div class="font-weight-bold mb-1 map-help-section-title">
                  우측 상단 (모듈리스트)
                </div>
                <table class="map-help-table mb-3">
                  <tr>
                    <td class="map-help-tool-cell">
                      <span class="map-help-tool-chip">
                        <v-icon small :color="mapToolbarToggleIconIdle"
                          >mdi-file-tree</v-icon
                        >
                        <span class="map-help-tool-caption">{{
                          $t('map.toolbarCaptionModuleList')
                        }}</span>
                      </span>
                    </td>
                    <td class="map-help-desc-cell">
                      <strong>모듈리스트 ON/OFF</strong> — 우측 drawer와 지도
                      <strong>모듈 폴리곤</strong>(있는 경우)을 함께 열고 닫습니다. Array →
                      String → 모듈 트리에서 패널 단위로 결함을 확인하고, 항목 선택 시 지도에서
                      해당 영역이 강조됩니다. 마커·AI 결함 표시와 <strong>독립</strong>입니다.
                    </td>
                  </tr>
                </table>

                <div class="font-weight-bold mb-1 map-help-section-title">
                  상단 툴바 (왼쪽 → 오른쪽, 사용빈도 순)
                </div>
                <table class="map-help-table mb-3">
                  <tr>
                    <td colspan="2" class="map-help-group-heading text--secondary text-caption py-1">
                      {{ $t('map.toolbarGroupAi') }}
                    </td>
                  </tr>
                  <tr>
                    <td class="map-help-tool-cell">
                      <span class="map-help-tool-chip">
                        <img
                          class="map-help-tool-img"
                          :class="mapToolbarRasterClass(false)"
                          :src="toolbarAiImgSrc"
                          width="24"
                          height="24"
                          alt=""
                        />
                        <span class="map-help-tool-caption">{{ $t('map.toolbarCaptionAi') }}</span>
                      </span>
                    </td>
                    <td class="map-help-desc-cell">
                      <strong>AI 검출 결함</strong>을 모듈 리스트·지도에 표시하거나 숨깁니다 (분석
                      실행 버튼이 아님). 지도 마커는 <strong>마커 ON</strong>일 때만 나타납니다.
                      분석 실행은 보고서 상세에서 수행합니다.
                      <span class="text--secondary">(관리자)</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="map-help-tool-cell">
                      <span class="map-help-tool-chip">
                        <v-icon small :color="mapToolbarToggleIconIdle">mdi-compare</v-icon>
                        <span class="map-help-tool-caption">{{
                          $t('map.toolbarCaptionAiDuplicate')
                        }}</span>
                      </span>
                    </td>
                    <td class="map-help-desc-cell">
                      버튼에 <strong>마우스를 올리면</strong> 메뉴가 열립니다.
                      <strong>자동</strong>(AI 중복 검출 제거) / <strong>수동</strong>(열화상 비교)
                      중 선택합니다.
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2" class="map-help-group-heading text--secondary text-caption py-1">
                      {{ $t('map.toolbarGroupReport') }}
                    </td>
                  </tr>
                  <tr>
                    <td class="map-help-tool-cell">
                      <span class="map-help-tool-chip">
                        <img
                          class="map-help-tool-img"
                          :src="toolbarReportSvgSrc"
                          width="22"
                          height="22"
                          alt=""
                        />
                        <span class="map-help-tool-caption">{{ $t('map.toolbarCaptionReport') }}</span>
                      </span>
                    </td>
                    <td class="map-help-desc-cell">
                      보고서 요약 다이얼로그를 엽니다. 동일 검사일 보고서를 선택해 통합 요약을
                      확인합니다.
                    </td>
                  </tr>
                  <tr>
                    <td class="map-help-tool-cell">
                      <span class="map-help-tool-chip">
                        <v-icon small :color="mapToolbarToggleIconIdle"
                          >mdi-file-document-multiple-outline</v-icon
                        >
                        <span class="map-help-tool-caption">{{
                          $t('map.toolbarCaptionDefectReport')
                        }}</span>
                      </span>
                    </td>
                    <td class="map-help-desc-cell">
                      결함 상세 보고서(유형·위치·이미지 등)를 확인·PDF로 저장합니다.
                    </td>
                  </tr>
                  <tr>
                    <td class="map-help-tool-cell">
                      <span class="map-help-tool-chip">
                        <img
                          class="map-help-tool-img"
                          :class="mapToolbarRasterClass(false)"
                          :src="require('@/assets/image/sumarary.png')"
                          width="24"
                          height="24"
                          alt=""
                        />
                        <span class="map-help-tool-caption">{{ $t('map.toolbarCaptionSummary') }}</span>
                      </span>
                    </td>
                    <td class="map-help-desc-cell">
                      결함 유형별 통계(유형명·개수)를 툴바 아래 표로 표시합니다.
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2" class="map-help-group-heading text--secondary text-caption py-1">
                      {{ $t('map.toolbarGroupDefect') }}
                    </td>
                  </tr>
                  <tr>
                    <td class="map-help-tool-cell">
                      <span class="map-help-tool-chip">
                        <v-icon small :color="mapToolbarToggleIconIdle">mdi-map-marker-check</v-icon>
                        <span class="map-help-tool-caption">{{
                          $t('map.toolbarTooltipMarkerToggle')
                        }}</span>
                      </span>
                    </td>
                    <td class="map-help-desc-cell">
                      지도 <strong>확정 결함 마커</strong> 표시를 켜거나 끕니다.
                      <strong>AI 결함 마커</strong>는 <strong>마커 ON</strong>과
                      <strong>AI ON</strong>이 모두 켜져 있을 때 지도에 표시됩니다.
                    </td>
                  </tr>
                  <tr>
                    <td class="map-help-tool-cell">
                      <span class="map-help-tool-chip">
                        <img
                          class="map-help-tool-img"
                          :src="toolbarMapMarkerSvgSrc"
                          width="22"
                          height="22"
                          alt=""
                        />
                        <span class="map-help-tool-caption">{{ $t('map.toolbarCaptionMarker') }}</span>
                      </span>
                    </td>
                    <td class="map-help-desc-cell">
                      <strong>마커 ON/OFF</strong> 바로 옆 버튼. 결함 마커
                      <strong>위치 편집</strong> 모드를 켜고 끕니다 (표시 on/off와 별개).
                      <span class="text--secondary">(관리자)</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="map-help-tool-cell">
                      <span class="map-help-tool-chip">
                        <v-icon small :color="mapToolbarToggleIconIdle">mdi-filter-variant</v-icon>
                        <span class="map-help-tool-caption">{{ $t('map.toolbarCaptionFilter') }}</span>
                      </span>
                    </td>
                    <td class="map-help-desc-cell">
                      결함 유형 필터 패널을 열고 닫습니다. 특정 유형만 지도에 표시할 수
                      있습니다.
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2" class="map-help-group-heading text--secondary text-caption py-1">
                      {{ $t('map.toolbarGroupMap') }}
                    </td>
                  </tr>
                  <tr>
                    <td class="map-help-tool-cell">
                      <span class="map-help-tool-chip">
                        <img
                          class="map-help-tool-img"
                          :class="mapToolbarRasterClass(false)"
                          :src="toolbarRgbImgSrc"
                          width="24"
                          height="24"
                          alt=""
                        />
                        <span class="map-help-tool-caption">{{ $t('map.toolbarCaptionRgbView') }}</span>
                      </span>
                    </td>
                    <td class="map-help-desc-cell">
                      선택한 열화상과 쌍(pair) RGB 이미지를 지도에 오버레이합니다. 결함 박스
                      윤곽을 확인할 수 있습니다.
                    </td>
                  </tr>
                  <tr>
                    <td class="map-help-tool-cell">
                      <span class="map-help-tool-chip">
                        <v-icon small :color="mapToolbarToggleIconIdle">mdi-layers</v-icon>
                        <span class="map-help-tool-caption">{{ $t('map.toolbarCaptionRgb') }}</span>
                      </span>
                    </td>
                    <td class="map-help-desc-cell">RGB 이미지 레이어를 지도에 켜고 끕니다.</td>
                  </tr>
                  <tr>
                    <td class="map-help-tool-cell">
                      <span class="map-help-tool-chip">
                        <v-icon small :color="mapToolbarToggleIconIdle">mdi-layers</v-icon>
                        <span class="map-help-tool-caption">{{ $t('map.toolbarCaptionIr') }}</span>
                      </span>
                    </td>
                    <td class="map-help-desc-cell">열화상 이미지 레이어를 지도에 켜고 끕니다.</td>
                  </tr>
                  <tr>
                    <td class="map-help-tool-cell">
                      <span class="map-help-tool-chip">
                        <v-icon small :color="mapToolbarToggleIconIdle">mdi-layers</v-icon>
                        <span class="map-help-tool-caption">{{ $t('map.toolbarCaptionGeoJson') }}</span>
                      </span>
                    </td>
                    <td class="map-help-desc-cell">GeoJSON 파일을 불러와 지도에 표시합니다.</td>
                  </tr>
                  <tr>
                    <td class="map-help-tool-cell">
                      <span class="map-help-tool-chip">
                        <v-icon small :color="mapToolbarToggleIconIdle">mdi-help-circle-outline</v-icon>
                        <span class="map-help-tool-caption">{{ $t('map.toolbarCaptionHelp') }}</span>
                      </span>
                    </td>
                    <td class="map-help-desc-cell">이 도움말을 엽니다.</td>
                  </tr>
                </table>

                <v-expansion-panels
                  v-model="helpExpandedPanels"
                  multiple
                  flat
                  class="map-help-panels"
                >
                  <v-expansion-panel>
                    <v-expansion-panel-header class="map-help-panel-header font-weight-medium py-2">
                      <div class="map-help-panel-header-inner">
                        <v-icon x-small class="map-help-panel-header-icon">mdi-swap-horizontal</v-icon>
                        <span>모듈리스트 · 마커 · AI 결함</span>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="map-help-panel-content">
                      <ol class="map-help-ordered-list mb-0">
                        <li>
                          <span class="map-help-inline-chip mr-1">
                            <v-icon x-small :color="mapToolbarToggleIconIdle"
                              >mdi-file-tree</v-icon
                            >
                            <strong>모듈리스트 ON/OFF</strong>
                          </span>
                          — drawer·모듈 폴리곤·패널 단위 트리를 엽니다. 모듈 색상:
                          <span class="map-help-color-swatch map-help-color-swatch--ok" />초록(결함
                          없음),
                          <span class="map-help-color-swatch map-help-color-swatch--warn" />노랑(결함
                          1건 이상). 트리에서 모듈을 선택하면 지도가 해당 패널을 강조합니다.
                        </li>
                        <li>
                          <span class="map-help-inline-chip mr-1">
                            <v-icon x-small :color="mapToolbarToggleIconIdle"
                              >mdi-map-marker-check</v-icon
                            >
                            <strong>마커 ON/OFF</strong>
                          </span>
                          — 확정·AI 결함 마커를 지도에 표시합니다. 마커를 클릭·드래그해 결함 위치를
                          확인·보정할 수 있습니다.
                        </li>
                        <li>
                          <span class="map-help-inline-chip mr-1">
                            <img
                              class="map-help-tool-img"
                              :class="mapToolbarRasterClass(false)"
                              :src="toolbarAiImgSrc"
                              width="16"
                              height="16"
                              alt=""
                            />
                            <strong>AI 결함 ON/OFF</strong>
                          </span>
                          — AI 검출 결함을 모듈 리스트·지도에 표시합니다. 지도 마커는
                          <strong>마커 ON</strong>과 함께 켜져 있어야 합니다.
                        </li>
                        <li>
                          세 버튼은 서로 <strong>독립</strong>이며 동시에 ON으로 둘 수 있습니다.
                          모듈 폴리곤이 없는 사이트는 drawer에
                          <strong>결함 매칭 정보(Array·String·Module)</strong>만 트리로
                          표시됩니다.
                        </li>
                      </ol>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-expansion-panel>
                    <v-expansion-panel-header class="map-help-panel-header font-weight-medium py-2">
                      <div class="map-help-panel-header-inner">
                        <v-icon x-small class="map-help-panel-header-icon">mdi-vector-link</v-icon>
                        <span>결함 마커 → 모듈 매핑</span>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="map-help-panel-content">
                      <ol class="map-help-ordered-list mb-0">
                        <li>
                          <strong>① 열화상 선택</strong> — 좌측
                          <v-icon x-small class="mx-1">mdi-thermometer</v-icon>
                          <strong>{{ $t('map.toolbarCaptionThermal') }}</strong> 패널에서 열화상을
                          선택합니다.
                        </li>
                        <li>
                          <strong>② 마커 확인</strong> — 지도에서 결함 마커를 클릭하면 팝업이
                          열립니다. 팝업의 IR 이미지와 지도상 마커 위치가 서로 일치하는지
                          확인합니다.
                        </li>
                        <li>
                          <strong>③ 마커 위치 수정</strong> — 위치가 맞지 않으면
                          <span class="map-help-inline-chip mr-1">
                            <img
                              class="map-help-tool-img"
                              :src="toolbarMapMarkerSvgSrc"
                              width="16"
                              height="16"
                              alt=""
                            />
                            <strong>{{ $t('map.toolbarCaptionMarker') }}</strong>
                          </span>
                          (<strong>{{ $t('map.editMapMarker') }}</strong>) 버튼을 눌러 수정 모드를
                          켠 뒤, 마커를 드래그해 올바른 모듈 위로 이동합니다. 저장 후 모듈
                          폴리곤 색상이 갱신됩니다.
                        </li>
                      </ol>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-expansion-panel>
                    <v-expansion-panel-header class="map-help-panel-header font-weight-medium py-2">
                      <div class="map-help-panel-header-inner">
                        <v-icon x-small class="map-help-panel-header-icon"
                          >mdi-format-list-bulleted</v-icon
                        >
                        <span>모듈리스트 활용</span>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="map-help-panel-content">
                      <ul class="map-help-basic-list mb-0">
                        <li>
                          <strong>모듈리스트(View)</strong>가 열리면 우측 drawer에 패널(<strong>모듈
                          ID</strong>)별 결함 현황이 트리로 표시됩니다.
                        </li>
                        <li>패널 행 오른쪽에 결함 유형 아이콘·수정 버튼이 표시됩니다.</li>
                        <li>
                          <strong>미지정 패널</strong>은 모듈에 연결되지 않은 결함을 모읍니다.
                        </li>
                        <li>트리에서 항목을 선택하면 지도에서 해당 영역이 강조됩니다.</li>
                        <li>
                          결함 유형 필터는 상단 툴바 <strong>필터</strong> 버튼에서 설정합니다.
                        </li>
                        <li>결함 삭제·상세 수정은 지도 마커 팝업에서도 할 수 있습니다.</li>
                        <li class="d-flex align-start">
                          <v-icon x-small class="map-help-basic-icon mt-1">mdi-magnify</v-icon>
                          <span
                            >검색창으로 결함 <strong>ID</strong>·<strong>유형</strong>·패널
                            ID·열화상 파일명을 찾을 수 있습니다.</span
                          >
                        </li>
                      </ul>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-expansion-panel>
                    <v-expansion-panel-header class="map-help-panel-header font-weight-medium py-2">
                      <div class="map-help-panel-header-inner">
                        <v-icon x-small class="map-help-panel-header-icon">mdi-filter-variant</v-icon>
                        <span>리스트 필터 칩</span>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="map-help-panel-content">
                      <p class="map-help-filter-note mb-2">
                        칩을 다시 클릭하면 <strong>전체</strong> 보기로 돌아갑니다. 숫자는 현재
                        보고서 기준 건수입니다.
                      </p>
                      <table class="map-help-table map-help-filter-table mb-0">
                        <tr>
                          <td class="map-help-tool-cell">
                            <v-chip
                              x-small
                              outlined
                              color="primary"
                              class="map-help-filter-chip px-2"
                            >
                              전체
                            </v-chip>
                          </td>
                          <td class="map-help-desc-cell">
                            모든 결함을 표시합니다. 다른 필터를 해제할 때도 이 칩을 누릅니다.
                          </td>
                        </tr>
                        <tr>
                          <td class="map-help-tool-cell">
                            <v-chip x-small outlined class="map-help-filter-chip px-2">
                              AI 탐지
                            </v-chip>
                          </td>
                          <td class="map-help-desc-cell">
                            AI가 자동 검출한 결함만 표시합니다.
                          </td>
                        </tr>
                        <tr>
                          <td class="map-help-tool-cell">
                            <v-chip x-small outlined class="map-help-filter-chip px-2">
                              수동 등록
                            </v-chip>
                          </td>
                          <td class="map-help-desc-cell">
                            사용자가 직접 등록·수정한 결함만 표시합니다. (AI 검출이 아닌 항목)
                          </td>
                        </tr>
                        <tr>
                          <td class="map-help-tool-cell">
                            <v-chip x-small outlined class="map-help-filter-chip px-2">
                              매핑 완료
                            </v-chip>
                          </td>
                          <td class="map-help-desc-cell">
                            태양광 모듈(패널)에 연결된 결함만 표시합니다. 모듈
                            <strong>미지정</strong> 결함은 제외됩니다.
                          </td>
                        </tr>
                      </table>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn text color="primary" @click="helpDialogOpen = false">닫기</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- 여기까지 Defect Summary 부분 -->
          <v-card-text v-if="defectTypeSelectShow" class="map-defect-filter-panel py-2 px-3">
            <v-combobox
              v-model="defectFilters"
              class="map-defect-filter-combobox"
              :items="defectTypes"
              item-text="name"
              item-value="id"
              multiple
              hide-details
              :label="$t('defects.selectFilter')"
              small
              :append-icon="defectFilters.length ? 'mdi-close' : ''"
              :aria-label="$t('defects.selectFilter')"
              @click:append="clearDefectFilters"
            >
              <template slot="selection" slot-scope="{ item, index }">
                <v-chip v-if="index === 0" small clickable @click.stop="removeDefectFilter(item)">
                  <span>{{ item.name }}</span>
                </v-chip>
                <v-chip v-if="index === 1" small clickable @click.stop="removeDefectFilter(item)">
                  <span>{{ item.name }}</span>
                </v-chip>
                <span
                  v-if="index === 2"
                  class="text-caption"
                  style="font-size: medium !important; color: var(--v-text-base)"
                >
                  +{{ defectFilters.length - 2 }}
                </span>
              </template>
            </v-combobox>
          </v-card-text>
        </v-card>
      </div>
        <div class="map-right-overlay-tools">
          <!-- 모듈리스트 ON/OFF — 우측 Drawer와 공간적으로 대응(맨 오른쪽) -->
          <div class="mini-img toolbarmap_color map-toolbar-tool-block map-defect-view-toggle">
            <MapToolbarTooltipBlock
              block-class=""
              caption-spacing="relaxed"
              icon-area-size="sm"
              caption-i18n-key="map.toolbarCaptionModuleList"
              :tooltip-text="
                moduleListOpen
                  ? $t('map.toolbarTooltipModuleListOn')
                  : $t('map.toolbarTooltipModuleListOff')
              "
              active-variant="primary"
              :active="moduleListOpen"
              :btn-props="moduleListToolbarBtnProps"
              btn-class="map-toolbar-module-list-btn"
              @click.stop="toggleModuleList"
            >
              <v-icon
                :color="mapToolbarToggleIconColor(moduleListOpen)"
                class="map-toolbar-mdi-icon"
              >
                mdi-file-tree
              </v-icon>
            </MapToolbarTooltipBlock>
          </div>
        </div>
      </div>
    </div>
    <div id="map-popup" class="ol-popup">
      <div class="ol-popup-header d-flex align-center justify-space-between">
        <span
          id="ol-popup-map-defect-heading"
          class="ol-popup-header__title flex-grow-1 min-width-0 text-truncate pr-2 d-none"
          aria-hidden="true"
        />
        <v-btn
          id="map-popup-closer"
          type="button"
          icon
          small
          elevation="0"
          class="ol-popup-closer-btn solvit-dialog-form-header__close flex-shrink-0"
          :aria-label="$t('common.close')"
          :ripple="false"
        >
          <v-icon size="22">mdi-close</v-icon>
        </v-btn>
      </div>
      <div id="map-popup-content" class="ol-popup-content d-flex flex-column">
        <div id="ol-popup-img-container" class="mb-3">
          <div id="ol-popup-img-wrapper"></div>
          <svg id="ol-popup-canvas"></svg>
        </div>
        <div id="ol-popup-content-table"></div>
      </div>
    </div>
    <ExamineReportSummaryDialog
      :dialog="reportSummaryDialogOpen"
      :report-name="getReportName"
      :report-ids="selectedReportIds"
      :summary-data="reportSummaryData"
      @close="closeReportSummaryDialog"
      @update:dialog="reportSummaryDialogOpen = $event"
    />
    <ExamineReportDetailDialog
      :dialog="reportDetailDialogOpen"
      :report-name="getReportName"
      :report-ids="selectedReportIds"
      :detail-data="reportDetailData"
      @close="closeReportDetailDialog"
      @update:dialog="reportDetailDialogOpen = $event"
    />
    <ImageLocationDialog
      :key="'site' + 'imageLocationData'"
      :dialog="imageLocationDialog"
      :v-if="imageLocationDialog"
      :image-location-summary="imageLocationSummary"
      :recommend-img-pos="recommendImgPos"
      :image-position="imagePosition"
      :image-processing-result="imageProcessingResult"
      @close="CloseImageLocationDialog"
      @update:dialog="imageLocationDialog = $event"
      @open-files="openFileDialog"
    />
    <ReportSelectionDialog
      :dialog="showReportSelectionDialog"
      :reports="sameExamineDateReports"
      :current-report-id="getReportId"
      :loading="reportSummaryLoading"
      @confirm="onReportSelectionConfirm"
      @cancel="onReportSelectionCancel"
      @update:dialog="showReportSelectionDialog = $event"
    />
    <ThermalImageComparisonDialog
      :visible="thermalImageComparisonDialogOpen"
      :report-id="getReportId"
      @update:visible="thermalImageComparisonDialogOpen = $event"
      @defects-removed="onAiDuplicateDefectsRemoved"
    />
    <AiDefectDedupDialog
      :visible="aiDedupDialogOpen"
      :report-id="getReportId"
      @update:visible="aiDedupDialogOpen = $event"
      @applied="onAiDedupApplied"
      @deleted="onAiDedupDeleted"
    />
  </div>
</template>
<script>
  import DotSolarMap from './DotSolarMap';
  import DotSolarMapContext from './DotSolarMapContext';
  import siteChangeManager from '../../utils/siteChangeManager';
  import { optimizeCanvasPerformanceVue } from '@/utils/canvasOptimizer';
  import { validateDefectFeatures } from '@/features/defect/schemas/defectSchema';
  // import SolarContext from "../../apps/SolarContext";
  // import Api from "../../apis/Api";
  import { SolarRgbImageService } from '../../_services';
  import { defectTypeApi } from '../../apis/defect.type.api';
  import { resolveDefectTypeRowId } from '@/utils/defectTypeRestIdentity';
  import { resetDefectStyleDebugLog } from '@/utils/map/layerFeatureStyles';
  import {
    recordSyncIntent,
    SyncReason,
    nextPipelineCorrelationId,
    refreshReportDefectLayerFull
  } from '@/map/reportDefectPipeline';
  import ImageUtil from '../../components/image/ImageUtils';
  import ExifAnalyzer from '../../components/image/ExifAnalyzer';
  import { Fill, Stroke, Style } from 'ol/style';
  import * as olSource from 'ol/source';
  import * as olFormat from 'ol/format';
  import * as olLayer from 'ol/layer';
  import Overlay from 'ol/Overlay';
  import DotMapStyle from './DotMapStyle';
  import MapToolbarTooltipBlock from './MapToolbarTooltipBlock.vue';
  import { mapGetters, mapActions, mapState } from 'vuex';
  import {
    buildModulePolygonLayer,
    createModuleHierarchyMapController,
    applyModuleHierarchyHighlightStyles,
    createMapHierarchyBookmarkOverlayElement,
    filterDefectsForHierarchyTarget,
    resolveBookmarkAnchorPosition,
    resolveHierarchyPks,
    shouldShowMapSelectionOverlay,
    shouldFitMapToHierarchyTarget,
    fitMapToFeatures,
    classifyMapFeatureClick,
    MAP_FEATURE_CLICK_KIND
  } from '@/features/dashboard-map';
  import {
    logModuleListDebug,
    logModuleListSync,
    resolveEnrichHierarchyCommit,
    summarizeDefectHierarchySample,
    summarizeDefectModuleLinkage,
    summarizeHierarchyTree
  } from '@/features/defect-drawer/utils/moduleListSyncDebug';
  import { isAppDebugEnabled, logExpandedDebug } from '@/utils/debug/expandedConsoleLog';
  import {
    installDefectModuleGeoVerifyBridge,
    maybeRunDefectModuleGeoVerification
  } from '@/utils/debug/defectModuleGeoVerify';
  import { installDefectModuleListMappingDebugBridge } from '@/utils/debug/defectModuleListMappingDebug';
  import {
    buildDefectModuleDisplayKey,
    buildModuleDisplayKey
  } from '@/features/defect-drawer/utils/defectModuleMatch';
  import { findSolarModuleAtCoordinate } from '@/features/defect-drawer/utils/findSolarModuleAtCoordinate';
  import {
    enrichWfsDefectRowsFromSolarModules,
    clearModuleHierarchyInfoCache
  } from '@/features/defect-drawer/utils/enrichWfsDefectRowsFromSolarModules';
  import ExamineReportSummaryDialog from '../dialog/ExamineReportSummaryDialog.vue';
  import ExamineReportDetailDialog from '../dialog/ExamineReportDetailDialog.vue';
  import ImageLocationDialog from '../dialog/ImageLocationDialog.vue';
  import ReportSelectionDialog from '../dialog/ReportSelectionDialog.vue';
  import ThermalImageComparisonDialog from '../dialog/ThermalImageComparisonDialog.vue';
  import AiDefectDedupDialog from '../dialog/AiDefectDedupDialog.vue';
  import ThermalDataHolder from '../../modules/thermal/ThermalDataHolder';
  import { formatThermalStatValue } from '@/utils/thermal/formatThermalStatValue';
  import { SolarExamineReportApi } from '../../apis/solar.examine.report.api';
  import { processImageUrlForCdn } from '@/utils/imagePolygonManager/imageLoader';
  import {
    mapToolbarActiveStyle as resolveMapToolbarActiveStyle,
    mapToolbarBtnStateClasses,
    mapToolbarOnPrimaryBtnStyle as resolveMapToolbarOnPrimaryBtnStyle,
    mapToolbarOnPrimaryIconColor as resolveMapToolbarOnPrimaryIconColor,
    mapToolbarPressedToggleBtnProps as resolveMapToolbarPressedToggleBtnProps,
    mapToolbarToggleBtnStyle as resolveMapToolbarToggleBtnStyle,
    mapToolbarToggleIconColor as resolveMapToolbarToggleIconColor
  } from '@/utils/mapToolbarTheme';
  import { appPerfMark, appPerfMeasure, appPerfSinceMyProfile } from '@/utils/appBootstrapPerfLog.js';

  /** 열화상 미리보기 v-img 고정 크기(CSS px) — SCSS $thermal-ir-preview-img-w/h 와 동기 (frontend_bu_260515) */
  const THERMAL_IR_PREVIEW_IMG_W_PX = 640;
  const THERMAL_IR_PREVIEW_IMG_H_PX = 512;

  export default {
    name: 'DotSolarMapBox',
    components: {
      ExamineReportSummaryDialog,
      ExamineReportDetailDialog,
      ImageLocationDialog,
      ReportSelectionDialog,
      ThermalImageComparisonDialog,
      AiDefectDedupDialog,
      MapToolbarTooltipBlock
    },
    props: {
      mapSize: {
        type: Object,
        default: () => ({ width: 800, height: 600 })
      },
      mapEditable: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        isRgbHovered: false,
        tooltipVisible: false,
        rgbCloseBtn: false,
        report: null,
        closeOnClick: false,
        /** 열화상 IR 패널(v-menu) 열림 — 닫기 버튼·외부 클릭과 연동 */
        thermalIrMenuOpen: false,
        /** 미리보기 위 커서 온도 툴팁 위치(패널 내부 px) */
        thermalHoverReadout: {
          show: false,
          x: 0,
          y: 0
        },
        imageOnMap: undefined,
        visibleImageOnMap: false,
        editingMapFlag: false,
        /** 사용자 의도: 결함 마커 표시 여부 (모듈리스트·AI와 독립) */
        markersWanted: true,
        /** siteDesign 계층 캐시 — drawer 닫을 때 store 비우고 재열 때 복원 */
        cachedModuleHierarchy: null,
        /** 지도 사용 도움말 다이얼로그 */
        helpDialogOpen: false,
        helpExpandedPanels: [],
        rgbImage: undefined,
        thermalImage: null,
        pointThermalValue: null,
        maxThermalValue: null,
        minThermalValue: null,
        averageThermalValue: null,
        reportSummaryDialogOpen: false,
        reportDetailDialogOpen: false,
        reportDetailLoading: false,
        reportDetailData: null,
        /** 보고서 선택 다이얼로그 확정 시 생성할 보고서 종류: 'summary' | 'detail' */
        reportSelectionMode: 'summary',
        imageLocationDialog: false,
        defectTypeSelectShow: false,
        defectFilters: [],
        defectTypes: [],
        thermalDataHolder: new ThermalDataHolder(),
        showDefectSummaryTable: false,
        readRGBLoading: false,
        imageLocationSummary: null,
        recommendImgPos: null,
        imagePosition: null,
        imageProcessingResult: null,
        thermalImageComparisonDialogOpen: false,
        /** AI 중복제거 방식 선택 메뉴 (자동 그룹 / 수동 비교) */
        aiDedupMenuOpen: false,
        /** AI 중복검출 자동 그룹 검토 다이얼로그 */
        aiDedupDialogOpen: false,
        // 보고서 관련 새로운 상태
        reportSummaryLoading: false,
        sameExamineDateReports: [],
        showReportSelectionDialog: false,
        selectedReportIds: [],
        reportSummaryData: null,

        // 레이어 토글 상태
        rgbLayerVisible: false,
        irLayerVisible: false,
        geoJsonLayerVisible: false,
        rgbLayerLoading: false,
        irLayerLoading: false,
        // Solar Module 레이어 관련
        /** siteDesign API 모듈 폴리곤 레이어 */
        solarModuleLayer: null,
        /** solarModuleLayer 생성 시 사용한 siteId (사이트 변경 시 재로드) */
        solarModuleLayerSiteId: null,
        // 파일 처리 중복 방지
        isProcessingFiles: false,
        isRenewingDefectList: false,
        isRefreshingMapLayers: false,
        exifAnalyzer: null, // EXIF 분석 도구
        // 이미지 정렬 방식 (기본값: 시간순)
        currentImageSortOrder: 'time',
        /** idle | loading | ready | unavailable — 열화상 온도 그리드 API(ThermalDataHolder) 결과 */
        thermalTemperatureStatsStatus: 'idle',
        /** 짧은 간격으로 여러 번 불리는 refreshModuleDefectLayer → WFS 중복 요청 합치기 */
        refreshDefectLayerSeq: 0,
        refreshDefectLayerTimer: null,
        /** changeImage 한 번마다 증가 — 열화상 온도 API·RGB API 늦은 응답이 현재 선택과 맞을 때만 반영 */
        changeImageGeneration: 0,
        rgbViewGeneration: 0,
        /** 지도에 올린 RGB GeoImage가 어느 열화상(pair) 기준인지 — 열화상 변경 시 재로드 판별 */
        lastMapRgbThermalId: null,
        /** 모듈리스트 토글 — siteDesign API 응답 전 스피너 + 재클릭 차단 */
        moduleListLoading: false,
        /** applyModuleListState 동시 실행 구분 */
        moduleListApplyToken: 0
      };
    },

    created() {
      // View 모드: 트리 선택 → 지도 하이라이트 (비반응 내부 상태 — `_` 키는 data()에 둘 수 없음)
      this._highlightedFeatures = null;
      this._selectionOverlay = null;
      /** siteDesign 전체 모듈 피처 캐시 */
      this._allModuleFeaturesCache = null;
      /** enrichWfsDefectRows — WFS·siteDesign 레이스 시 중복 API 호출 방지 */
      this._enrichDefectHierarchyPromise = null;
      /** 모듈 폴리곤 백그라운드 prefetch (중복 요청 방지) */
      this._solarModuleLayerPrefetchPromise = null;
      /** Module Hierarchy Map — 캐시 ↔ source 동기화 (다른 지도에서도 동일 패턴) */
      this._moduleHierarchyMapController = null;
    },

    mounted() {
      appPerfMark('DotSolarMapBox:mounted', {
        reportId: this.getReportId,
        siteId: this.getSite?.id
      });
      appPerfSinceMyProfile('DotSolarMapBox:mounted');
      appPerfMark('DotSolarMapBox:initializeMap:start');
      this.initializeMap();
      appPerfMeasure('DotSolarMapBox:initializeMap', 'DotSolarMapBox:initializeMap:start');
      if (this.moduleListOpen) {
        this.$nextTick(() => {
          this._runApplyModuleListState(true);
        });
      }
      this.exifAnalyzer = new ExifAnalyzer();
      // defectTypes는 항상 로드하되, getReportId가 있을 때만 결함 마커도 함께 로드
      appPerfMark('DotSolarMapBox:loadDefectMarkers:start');
      this.loadDefectMarkers({ source: 'mounted' });
      appPerfMark('DotSolarMapBox:loadDefectMarkers:dispatched');
      this.$store.commit('dashboard/setToolbarDefectFilters', this.defectFilters || []);

      // 🆕 Canvas 성능 최적화 설정
      this.$nextTick(() => {
        optimizeCanvasPerformanceVue(this, 'map', 'DotSolarMapBox');
      });

      // [Refactor] Mounted 로직 제거
      // getReportId 유무에 따른 MapMenu 제어는 이제 watcher나 store 상태에 의해 처리됨.
      // 기존 로직:
      // ...
      // if (this.getReportId) {
      //   this.setMapMenu(true);
      // } else this.setMapMenu(false);

      //좌상단의 이미지 위치 표시 버튼 클릭시
      this.$eventBus.$off('show-images-location', this.onShowImagesLocationEvent);
      this.$eventBus.$on('show-images-location', this.onShowImagesLocationEvent);
      this.$eventBus.$off('defect-coords-adjusted');
      this.$eventBus.$on('defect-coords-adjusted', this.onDefectCoordsAdjusted);
      this.$eventBus.$off('map-defect-layer-ready', this.onMapDefectLayerReady);
      this.$eventBus.$on('map-defect-layer-ready', this.onMapDefectLayerReady);
      this.$eventBus.$off('map-defect-layer-error', this.onMapDefectLayerError);
      this.$eventBus.$on('map-defect-layer-error', this.onMapDefectLayerError);
      this.$eventBus.$off('map-ai-defect-layer-ready', this.onMapAiDefectLayerReady);
      this.$eventBus.$on('map-ai-defect-layer-ready', this.onMapAiDefectLayerReady);
      this.$eventBus.$off('defect-module-geo-verify-click', this.onDefectModuleGeoVerifyClick);
      this.$eventBus.$on('defect-module-geo-verify-click', this.onDefectModuleGeoVerifyClick);

      if (isAppDebugEnabled()) {
        installDefectModuleGeoVerifyBridge(() => this.getDefectModuleGeoVerifyContext());
        installDefectModuleListMappingDebugBridge(() => this.getDefectModuleListDiagContext());
      }
      // USER-STEPS는 bridge 설치 시 1회만 출력

      // Vuex mutation 감지: wfsDefectRows 변경 시 모듈 색상 갱신
      this._unsubscribeModuleColors = this.$store.subscribe(mutation => {
        const isWfsRowsMutation =
          mutation.type === 'dashboard/removeWfsDefectRow' ||
          mutation.type === 'dashboard/setWfsDefectRows';
        if (isWfsRowsMutation) {
          this.$nextTick(() => {
            this.syncMapLayers();
          });
          if (mutation.type === 'dashboard/setWfsDefectRows' && this.moduleListOpen) {
            this.$nextTick(async () => {
              const hierarchy =
                this.$store.state.dashboard?.siteDesignModuleHierarchy || [];
              if (!hierarchy.length) {
                await this.enrichDefectRowsModuleHierarchy();
              }
            });
          }
          if (this.solarModuleLayer || this._allModuleFeaturesCache?.length) {
            this.$nextTick(() => {
              if (this.moduleListOpen) {
                const highlight = this.$store.state.dashboard?.mapHighlightTarget;
                if (highlight) {
                  this.applyTreeHighlight(highlight);
                } else {
                  this.applyModuleDefectColors();
                }
              } else {
                this.applyModuleDefectColors();
              }
            });
          }
        }
        // EventBus → Vuex: defect-fly-to-coordinate
        if (mutation.type === 'dashboard/setDefectFlyTarget' && mutation.payload) {
          this.onDefectFlyToCoordinate(mutation.payload);
        }
        // 트리 선택 → 지도 하이라이트 / 해제 시 책갈피 제거
        if (mutation.type === 'dashboard/setMapHighlightTarget') {
          if (!mutation.payload) {
            this._clearSelectionLabel();
            this._highlightedFeatures = null;
            return;
          }
          this.$nextTick(() => {
            try {
              this.applyTreeHighlight(mutation.payload, {
                fitView: shouldFitMapToHierarchyTarget(mutation.payload)
              });
            } catch (err) {
              console.error('[DotSolarMapBox] applyTreeHighlight failed', err);
            }
          });
        }
      });

      if (this.getReportId) {
        appPerfMark('DotSolarMapBox:reportRestore:start', { reportId: this.getReportId });
        // 다른페이지 갔다가 와서 site, reportId가 있는 경우 에도 지도의 위치랑 getsite의 위치가 다르면 다시 지도로 이동해야함
        if (this.getSite === undefined || this.getSite === null) {
          appPerfMark('DotSolarMapBox:reportRestore:skip', { reason: 'no site' });
          //site값이 없으면 정상적인 접근방법이 아님
          return;
        } else if (this.getSite && this.getSite.id) {
          //site값이 있으면 이동
          siteChangeManager.handleSiteNavigation(this.getSite);
          // 초기 AI 버튼 상태에 따른 loading 처리
          if (this.getShowAiDefectFlag) {
            this.toggleAndFetchData();
          }
        }
        appPerfMark('DotSolarMapBox:getDefectSummary:start');
        this.getDefectSummary(this.getReportId);
        appPerfSinceMyProfile('DotSolarMapBox:reportRestore:dispatched');
      }

      if (this.getSiteId) {
        this.$nextTick(() => this.prefetchSolarModuleLayer());
      }

      // window.addEventListener('open-defect-window', (e) => { alert(e.detail.defectId)})
    },

    computed: {
      ...mapState('dashboard', {
        moduleListOpen: 'defectDrawerOpen'
      }),
      ...mapGetters({ getReportId: 'explorer/getReportId' }),
      ...mapGetters({ getSite: 'explorer/getSite' }),
      ...mapGetters({ getReportName: 'explorer/getReportName' }),
      getSiteId() {
        return this.getSite?.id;
      },
      /** 중복제거 툴바 버튼 활성 — 메뉴 또는 두 다이얼로그 중 하나라도 열림 */
      aiDedupToolbarActive() {
        return (
          this.aiDedupMenuOpen ||
          this.aiDedupDialogOpen ||
          this.thermalImageComparisonDialogOpen
        );
      },
      ...mapGetters({ userProfile: 'user/getUserProfile' }),
      ...mapGetters({ getReport: 'explorer/getReport' }),
      ...mapGetters({ getMapMenu: 'explorer/getMapMenu' }),
      ...mapGetters({
        getReportSelectTaskComplete: 'explorer/getReportSelectTaskComplete'
      }),
      ...mapGetters({
        getShowExplorer: 'explorer/getShowExplorer'
      }),
      ...mapGetters({ getSelectedThermalImage: 'dashboard/getSelectedThermalImage' }),
      ...mapGetters({ getSelectedThermalImageIndex: 'dashboard/getSelectedThermalImageIndex' }),
      ...mapGetters({ getThermalImages: 'dashboard/getThermalImages' }),
      ...mapGetters({ getShowAiDefectFlag: 'dashboard/getShowAiDefectFlag' }),
      ...mapGetters({ getAiDefectLoading: 'dashboard/getAiDefectLoading' }),
      ...mapGetters({ shouldRenewDefectList: 'defect/shouldRenewDefectList' }),
      ...mapGetters({ shouldRefreshMap: 'defect/shouldRefreshMap' }),
      ...mapGetters({ mapRefreshRequestMeta: 'defect/mapRefreshRequestMeta' }),
      ...mapGetters({ shouldInitDefectCardTable: 'defect/shouldInitDefectCardTable' }),
      ...mapGetters('dashboard', {
        examineDefectSummaries: 'getExamineDefectSummaries'
      }),
      selectedThermalImage() {
        return this.getSelectedThermalImage;
      },
      /** 커서 위치 온도: 데이터 없을 때 'null ℃' 대신 '-' */
      thermalPointLabel() {
        if (this.thermalTemperatureStatsStatus !== 'ready') {
          return '-';
        }
        if (this.pointThermalValue === null || this.pointThermalValue === undefined) {
          return '-';
        }
        const n = Number(this.pointThermalValue);
        if (!Number.isFinite(n)) {
          return '-';
        }
        return `${n.toFixed(1)} ℃`;
      },
      isAIButtonActive: {
        get() {
          return this.getShowAiDefectFlag;
        },
        set(value) {
          this._logMapLayerDebug('AI분석 setter 진입', { nextShowAiDefect: value });
          this.setShowAiDefectFlag(value);
        }
      },
      /** 확정 결함 마커 레이어 = 마커 ON/OFF 의도 */
      defectLayerVisible() {
        return this.markersWanted;
      },
      /** AI 마커 레이어 = 마커 ON/OFF ∧ AI 결함 ON (지도 마커는 전체 일괄 제어) */
      aiLayerVisible() {
        return this.markersWanted && this.getShowAiDefectFlag;
      },
      /** 모듈 폴리곤 레이어 실제 표시 = 모듈리스트 열림 */
      moduleLayerVisible() {
        return this.moduleListOpen;
      },
      thermalPreviewImgWpx() {
        return THERMAL_IR_PREVIEW_IMG_W_PX;
      },
      thermalPreviewImgHpx() {
        return THERMAL_IR_PREVIEW_IMG_H_PX;
      },
      thermalPreviewImgSrc() {
        const url = this.thermalImage?.imgUrl;
        return url ? processImageUrlForCdn(url) : '';
      },
      defectFilterBadgeCount() {
        const n = this.defectFilters?.length || 0;
        return n > 99 ? '99+' : String(n);
      },
      defectFilterBadgeVisible() {
        return (this.defectFilters?.length || 0) > 0;
      },
      defectFilterTooltipText() {
        const base = this.$t('defects.filter');
        const n = this.defectFilters?.length || 0;
        return n > 0 ? `${base} (${n})` : base;
      },
      activeThemePrimary() {
        return this.$vuetify.theme.currentTheme?.primary || 'primary';
      },
      /** 맵 툴바 토글 비활성: 다크에서 흰색 통일, 라이트에서는 mapToolIcon (info/error 혼용 제거) */
      mapToolbarToggleIconIdle() {
        return this.$vuetify.theme.dark ? 'mapToolIconOnPrimary' : 'mapToolIcon';
      },
      /** 레이어 스택 v-btn style.color — 라이트는 mapToolIcon, 다크는 onPrimary (MDI·리플과 동일 토큰) */
      mapToolbarStackBtnForegroundVar() {
        return this.$vuetify.theme.dark
          ? 'var(--v-mapToolIconOnPrimary-base)'
          : 'var(--v-mapToolIcon-base)';
      },
      /** 모듈리스트 토글 — primary 눌림 토글 공통 */
      moduleListToolbarBtnProps() {
        return resolveMapToolbarPressedToggleBtnProps(this.$vuetify, {
          active: this.moduleListOpen,
          loading: this.moduleListLoading
        });
      },
      defectMarkerToolbarBtnProps() {
        return resolveMapToolbarPressedToggleBtnProps(this.$vuetify, {
          active: this.markersWanted,
          extra: { icon: true }
        });
      },
      aiToolbarBtnProps() {
        return resolveMapToolbarPressedToggleBtnProps(this.$vuetify, {
          active: this.isAIButtonActive,
          loading: this.getAiDefectLoading,
          extra: { icon: true }
        });
      },
      toolbarIconColorHex() {
        const t = this.$vuetify.theme.currentTheme;
        if (this.$vuetify.theme.dark) {
          return t?.mapToolIconOnPrimary || '#FFFFFF';
        }
        return t?.mapToolIcon || '#475569';
      },
      toolbarMapMarkerSvgSrc() {
        const color = encodeURIComponent(this.toolbarIconColorHex);
        // viewBox 안에서 축소해 꽉 찬 느낌 완화(옆 MDI·레이어 아이콘과 시각적 무게 맞춤)
        return (
          `data:image/svg+xml;utf8,` +
          `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>` +
          `<g transform='translate(12 12) scale(0.78) translate(-12 -12)'>` +
          `<path fill='${color}' d='M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5A2.5 2.5 0 1 1 12 6a2.5 2.5 0 0 1 0 5.5z'/>` +
          `<path fill='${color}' d='M3 21h18v1H3z' opacity='0.6'/>` +
          `</g></svg>`
        );
      },
      toolbarRgbImgSrc() {
        return this.$vuetify.theme.dark
          ? require('@/assets/image/rgb_white.png')
          : require('@/assets/image/rgb_active.png');
      },
      toolbarAiImgSrc() {
        return this.$vuetify.theme.dark
          ? require('@/assets/image/ai_white.png')
          : require('@/assets/image/ai_active.png');
      },
      toolbarReportSvgSrc() {
        const color = encodeURIComponent(this.toolbarIconColorHex);
        return (
          `data:image/svg+xml;utf8,` +
          `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>` +
          `<g transform='translate(12 12) scale(0.78) translate(-12 -12)'>` +
          `<path fill='${color}' d='M6 2h9l5 5v15H6V2zm8 1.5V8h4.5' opacity='0.95'/>` +
          `<path fill='${color}' d='M8 11h8v1.8H8V11zm0 3.2h8V16H8v-1.8zm0 3.2h6v1.8H8v-1.8z'/>` +
          `</g></svg>`
        );
      }
    },
    watch: {
      helpDialogOpen(open) {
        if (!open) {
          this.helpExpandedPanels = [];
        }
      },
      '$vuetify.theme.dark'() {
        this.$nextTick(() => DotSolarMap.refreshStylesForTheme());
      },
      // store에서 가져오는 site 정보 watch - 백업용 지도 이동 처리
      getSite: function (newSite) {
        if (newSite === undefined || newSite === null) return;
        console.log('DotSolarMapBox - getSite changed:', newSite);
        // [Refactor] 불필요한 로그 제거
        // console.log('DotSolarMapBox - oldSite:', oldSite);

        // SiteChangeManager를 통한 백업용 사이트 변경 처리
        // forceSiteChange → moveSite 가 defect 레이어를 제거만 함. 비동기 완료가
        // selectTreeItem 끝의 requestMapRefresh 보다 늦으면 아이콘이 다시 사라짐 → moveSite 직후 결함 WFS 재부착.
        this.removeSolarModuleLayer();
        if (newSite && newSite.id) {
          siteChangeManager.forceSiteChange(newSite).then(() => {
            if (this._isDestroyed) return;
            if (!this.getReportId) return;
            this.refreshModuleDefectLayer({
              reason: SyncReason.GET_SITE_WATCHER,
              source: 'watch.getSite.afterForceSiteChange'
            });
            this.prefetchSolarModuleLayer();
          });
        }

        // rotation 값이 있으면 지도 회전 설정
        if (newSite.rotation !== undefined && newSite.rotation !== null) {
          console.log(`store에서 받은 rotation 값: ${newSite.rotation}°`);
          this.setRotation(newSite.rotation);
        }
      },
      getReportId(newReportId, oldReportId) {
        if (newReportId) {
          console.log('[DotSolarMapBox] Report ID detected, enabling Map Menu');
          this.setMapMenu(true);
          this.$nextTick(() => {
            this.loadDefectMarkers({ source: 'watch.getReportId' });
          });
          if (
            String(newReportId) !== String(oldReportId ?? '') &&
            this.moduleListOpen &&
            DotSolarMap.map
          ) {
            this._runApplyModuleListState(true);
          }
        } else {
          this.setMapMenu(false);
          this.removeSolarModuleLayer();
        }
      },
      // 다른 라우트(예: admin)에서 대시보드로 돌아올 때 mounted와 함께 결함 레이어 동기화를 한 번 더 보장
      $route(to, from) {
        if (to.name === 'dashboard' && from && from.name !== 'dashboard') {
          this.$nextTick(() => {
            this.loadDefectMarkers({ source: 'watch.route.dashboardReturn' });
          });
        }
      },
      shouldRenewDefectList: async function (shouldRenew) {
        if (shouldRenew) {
          if (this.isRenewingDefectList) {
            return;
          }
          this.isRenewingDefectList = true;
          try {
            this.fetchDefects();
            await this.$store.dispatch('defect/completeDefectListRenew');
          } finally {
            this.isRenewingDefectList = false;
          }
        }
      },
      async shouldRefreshMap(shouldRefresh) {
        if (shouldRefresh) {
          if (this.isRefreshingMapLayers) {
            return;
          }
          this.isRefreshingMapLayers = true;
          try {
            const meta = this.mapRefreshRequestMeta;
            await this.refreshModuleDefectLayer({
              reason: SyncReason.SHOULD_REFRESH_MAP,
              source: 'watch.shouldRefreshMap',
              extra: meta
                ? {
                    correlationId: meta.correlationId,
                    storeMetaSource: meta.source,
                    storeMetaReason: meta.reason
                  }
                : {}
            });

            // this 컨텍스트 문제 해결을 위해 화살표 함수 사용
            if (this.getDefectSummary && typeof this.getDefectSummary === 'function') {
              this.getDefectSummary(this.getReportId);
            } else {
              console.warn('[DOT SOLAR MAP BOX] getDefectSummary 메서드를 찾을 수 없습니다');
            }

            // 갱신 완료 처리
            await this.$store.dispatch('defect/completeMapRefresh');
          } finally {
            this.isRefreshingMapLayers = false;
          }
        }
      },
      getSelectedThermalImage: function changeImage(thermalImg) {
        const keepThermalIrMenuOpen = this.thermalIrMenuOpen;
        this.thermalImage = thermalImg;
        const changeGen = ++this.changeImageGeneration;
        // 아래 처리를 하지 않고 return 한다.

        this.averageThermalValue = null;
        this.pointThermalValue = null;
        this.maxThermalValue = null;
        this.minThermalValue = null;

        if (!this.thermalImage) {
          this.thermalTemperatureStatsStatus = 'idle';
        } else if (!this.thermalImage.id) {
          this.thermalTemperatureStatsStatus = 'unavailable';
        } else {
          this.thermalTemperatureStatsStatus = 'loading';
          this.thermalDataHolder
            .load(this.thermalImage.id, {
              imgWidth: this.thermalImage.imgWidth,
              imgHeight: this.thermalImage.imgHeight
            })
            .then(result => {
              if (changeGen !== this.changeImageGeneration) {
                return;
              }
              this.averageThermalValue = result?.average;
              this.pointThermalValue = null;
              this.maxThermalValue = result?.max;
              this.minThermalValue = result?.min;
              this.thermalTemperatureStatsStatus = 'ready';
            })
            .catch(() => {
              if (changeGen !== this.changeImageGeneration) {
                return;
              }
              this.thermalTemperatureStatsStatus = 'unavailable';
            });
        }

        // 열화상 선택 시 지도 이동은 이 호출 한 번만 (사각형은 addFeature(..., { recenter: false })로 이중 이동 방지)
        if (this.thermalImage?.imgPosCoords) {
          DotSolarMap.moveToObjectCenter(this.thermalImage.imgPosCoords);
        }

        this.syncMapImageOverlay(changeGen);

        // 열화상 패널: 다른 이미지 선택 시에도 열린 상태 유지(미리보기·통계 갱신만)
        this.$nextTick(() => {
          if (keepThermalIrMenuOpen) {
            this.thermalIrMenuOpen = true;
          }
        });
      },
      async visibleImageOnMap(newVal) {
        const viewGen = ++this.rgbViewGeneration;
        try {
          this.readRGBLoading = true;
          await this.$nextTick();
          await this.applyMapRgbViewMode(newVal, viewGen);
        } catch (err) {
          console.error(err);
        } finally {
          if (viewGen === this.rgbViewGeneration) {
            this.readRGBLoading = false;
          }
        }
      },
      editingMapFlag(newVal) {
        DotSolarMap.setMapEditable(newVal);
      },
      markersWanted(newVal, oldVal) {
        this._logMapLayerDebug('watcher: markersWanted 변경', { from: oldVal, to: newVal });
        this.syncMapLayers();
        if (!newVal && this.editingMapFlag) {
          this._logMapLayerDebug('마커 의도 OFF → editingMapFlag false');
          this.editingMapFlag = false;
        }
      },
      getShowAiDefectFlag(newVal, oldVal) {
        this._logMapLayerDebug('watcher: showAiDefectFlag 변경', { from: oldVal, to: newVal });
        this.syncMapLayers();
      },
      moduleListOpen: {
        async handler(open) {
          this._logMapLayerDebug('watcher: moduleListOpen 변경', { open });
          await this._runApplyModuleListState(open);
        },
        immediate: true
      },
      /** 결함 필터 변경 시 WFS 레이어는 refreshModuleDefectLayer 단일 경로로만 갱신 */
      defectFilters(newFilters) {
        this.refreshModuleDefectLayer({
          reason: SyncReason.DEFECT_FILTERS_WATCH,
          source: 'watch.defectFilters'
        });
        this.$store.commit('dashboard/setToolbarDefectFilters', newFilters || []);
        this.$eventBus.$emit('defect-filtered', { filters: newFilters });
      },
      //정밀검사보고 선택시 mapMenu를 열었을 때 defect정보를 초기화
      getMapMenu(newVal) {
        if (newVal) {
          this.defectFilters = [];
        }
      },
      async getShowExplorer(newVal) {
        // 보고서 이미지 리스트에서 나와 탐색 트리로 돌아올 때(showExplorer true) 열화상 온도 확인 패널 닫기
        if (newVal) {
          this.thermalIrMenuOpen = false;
        }
        //해당 explorer로 접근했고 이미 기존 AI결함필터 flag가 true였으면.
        if (!newVal && this.getShowAiDefectFlag) {
          this.toggleAndFetchData();
        }
      },
      getReportSelectTaskComplete: {
        deep: true,
        async handler() {
          this.getDefectSummary(this.getReportId);
          this.setReportSelectTaskComplete(false);
        }
      },
      // Loading 상태 변화 감지
      getAiDefectLoading(loading) {
        console.log('[DOT SOLAR MAP BOX] AI 결함 Loading 상태 변경:', loading);
      }
    },

    beforeUnmount() {
      this.$eventBus.$off('show-images-location', this.onShowImagesLocationEvent);
      this.$eventBus.$off('defect-coords-adjusted', this.onDefectCoordsAdjusted);
      this.$eventBus.$off('map-defect-layer-ready', this.onMapDefectLayerReady);
      this.$eventBus.$off('map-ai-defect-layer-ready', this.onMapAiDefectLayerReady);
      this.$eventBus.$off('defect-module-geo-verify-click', this.onDefectModuleGeoVerifyClick);
      this._unsubscribeModuleColors?.();
      this._detachModuleClickHandler?.();
      this._clearSelectionLabel?.();
      //coreLeftDrawer emit showExplorer
      // this.$eventBus.$off("ClickShowExplorer");
      // this.$eventBus.$off("ClickCloseExplorer");

      //다른페이지 접근전에 닫기
      DotSolarMap.initState();
    },

    methods: {
      formatThermalStatValue,

      getDefectModuleGeoVerifyContext() {
        const layer = this.solarModuleLayer;
        const sourceFeatures = layer?.getSource?.()?.getFeatures?.() || [];
        const moduleFeatures = this._allModuleFeaturesCache?.length
          ? this._allModuleFeaturesCache
          : sourceFeatures;
        return {
          defects: this.$store.state.dashboard?.wfsDefectRows || [],
          moduleFeatures
        };
      },

      getDefectModuleListDiagContext() {
        const { defects, moduleFeatures } = this.getDefectModuleGeoVerifyContext();
        return {
          store: this.$store,
          moduleFeatures,
          defects,
          parentDefectTypes: this.$store.getters['defect/parentDefectTypes'] || [],
          resolveDefectTypeRowId
        };
      },

      runDefectModuleGeoVerifyIfReady(trigger = 'auto') {
        const { defects, moduleFeatures } = this.getDefectModuleGeoVerifyContext();
        return maybeRunDefectModuleGeoVerification(defects, moduleFeatures, trigger);
      },

      onDefectModuleGeoVerifyClick(payload = {}) {
        const defectSeq = payload.defectSeq ?? payload.seq ?? null;
        if (defectSeq == null) {
          return;
        }
        window.__solvitDefectModuleVerify?.verifyOne?.(defectSeq);
      },

      onDefectCoordsAdjusted(payload) {
        if (!payload?.detail) {
          return;
        }

        // 모듈 레벨 디바운스 (컴포넌트 인스턴스 중복에도 대응)
        if (!window.__defectCoordsAdjustedGuard) window.__defectCoordsAdjustedGuard = {};
        const guardKey = String(payload.defectId);
        const lastTime = window.__defectCoordsAdjustedGuard[guardKey] || 0;
        if (Date.now() - lastTime < 2000) return;
        window.__defectCoordsAdjustedGuard[guardKey] = Date.now();

        const msg = this.buildMarkerSavedMessage(payload.detail);
        this.notifyMapAlert({ type: 'success', message: msg });

        // WFS 전체 재조회 없이 store의 wfsDefectRows는 syncDefectCoordsAdjustMinimal 에서
        // 이미 patch 되었으므로 모듈 색상만 갱신 (WFS reload 시 마커 깜빡임 방지)
        if (this.solarModuleLayer) {
          this.$nextTick(() => {
            this.applyModuleDefectColors();
          });
        }
      },

      /** Module Hierarchy Map Controller — lazy init + 캐시 동기화 */
      _getModuleHierarchyController() {
        if (!this._moduleHierarchyMapController) {
          this._moduleHierarchyMapController = createModuleHierarchyMapController();
        }
        if (this._allModuleFeaturesCache?.length) {
          this._moduleHierarchyMapController.setFeatureCache(this._allModuleFeaturesCache);
        }
        return this._moduleHierarchyMapController;
      },

      /** 트리/지도 선택 → 계층(Array|String|Module) 가시 범위 + 하이라이트 */
      applyTreeHighlight(payload, options = {}) {
        const layer = this.solarModuleLayer;
        if (!layer || !DotSolarMap.map || !this.moduleListOpen) {
          logModuleListSync('map.applyTreeHighlight:skip', {
            hasLayer: Boolean(layer),
            hasMap: Boolean(DotSolarMap.map),
            moduleListOpen: this.moduleListOpen,
            payload
          });
          return;
        }

        const source = layer.getSource();
        if (!source) return;

        const controller = this._getModuleHierarchyController();
        const plan = controller.syncSource(source, payload);
        const pks = resolveHierarchyPks(payload);

        logModuleListSync('map.applyTreeHighlight:plan', {
          payload,
          pks,
          visibleFeatureCount: plan.visible?.length ?? 0,
          focusFeatureCount: plan.highlight?.focus?.length ?? 0,
          contextStringCount: plan.highlight?.contextString?.length ?? 0,
          contextArrayCount: plan.highlight?.contextArray?.length ?? 0,
          contextFeatureCount:
            (plan.highlight?.contextString?.length ?? 0) +
            (plan.highlight?.contextArray?.length ?? 0)
        });

        this._clearTreeHighlight();
        this._clearSelectionLabel();
        layer.setVisible(true);

        if (!plan.pks) {
          logModuleListSync('map.applyTreeHighlight:noPks', { payload });
          return;
        }

        if (!plan.visible.length) {
          logModuleListSync('map.applyTreeHighlight:noVisibleModules', { payload, pks });
          DotSolarMap.map.render();
          return;
        }

        this._highlightedFeatures = applyModuleHierarchyHighlightStyles(plan.highlight, {
          Style,
          Stroke,
          Fill,
          focusRowKind: payload.kind
        });

        // 책갈피 — Array/String 선택 시만 (Module은 Drawer·하이라이트만)
        if (shouldShowMapSelectionOverlay(payload)) {
          const anchorFeatures = plan.highlight?.focus?.length ? plan.highlight.focus : plan.visible;
          this._showSelectionLabel(anchorFeatures, payload, plan.highlight?.focus?.[0] ?? null);
        }
        if (options.fitView) {
          const fitFeatures = plan.highlight?.focus?.length
            ? plan.highlight.focus
            : plan.visible;
          const fitKey = `${payload.kind}:${payload.seq}`;
          const now = Date.now();
          if (
            this._hierarchyFitKey === fitKey &&
            now - (this._hierarchyFitAt || 0) < 80
          ) {
            logModuleListSync('map.applyTreeHighlight:skipDuplicateFit', { fitKey });
          } else {
            this._hierarchyFitKey = fitKey;
            this._hierarchyFitAt = now;
            fitMapToFeatures(DotSolarMap.map, fitFeatures);
          }
        }
        DotSolarMap.map.render();
      },

      /** 하이라이트 초기화 → 결함 유무 기본 스타일 복원 */
      _clearTreeHighlight() {
        this._highlightedFeatures = null;
        this.applyModuleDefectColors();
      },

      /** 선택 라벨 오버레이 — 좌상단 책갈피 + (Module 선택 시) 결함 목록 */
      _showSelectionLabel(features, target, focusFeature = null) {
        if (!shouldShowMapSelectionOverlay(target)) {
          this._clearSelectionLabel();
          return;
        }
        if (!features.length || !DotSolarMap.map || !target) {
          logModuleListSync('map.selectionLabel:skip', {
            featureCount: features?.length ?? 0,
            hasTarget: Boolean(target)
          });
          return;
        }

        const position = resolveBookmarkAnchorPosition(features);
        if (!position) {
          logModuleListSync('map.selectionLabel:noAnchor', { target });
          return;
        }

        const anchorFeature = focusFeature ?? features[0] ?? null;
        const wfsDefects = this.$store.state.dashboard?.wfsDefectRows || [];
        const defects = filterDefectsForHierarchyTarget(target, wfsDefects);
        const pks = resolveHierarchyPks(target);

        logModuleListSync('map.selectionLabel:defects', {
          target,
          pks,
          wfsDefects: summarizeDefectModuleLinkage(wfsDefects),
          filteredDefectCount: defects.length,
          filteredDefectSeqs: defects.slice(0, 8).map(d => d.seq),
          reasonIfEmpty:
            defects.length === 0
              ? 'WFS defects missing solarModuleSeq or no match for moduleSeq'
              : undefined
        });

        const el = createMapHierarchyBookmarkOverlayElement(target, anchorFeature, {
          defects,
          formatDefectSummary: moduleDefects =>
            this._formatMapDefectSummary(moduleDefects)
        });

        this._selectionOverlay = new Overlay({
          element: el,
          position,
          positioning: 'bottom-left',
          offset: [0, -4]
        });
        DotSolarMap.map.addOverlay(this._selectionOverlay);
      },

      _formatMapDefectSummary(defects) {
        const n = (defects || []).length;
        if (n <= 1) {
          return this.$t('defects.mapSelectionDefectPresent');
        }
        return this.$t('defects.mapSelectionDefectCount', { n });
      },

      /** 선택 라벨 오버레이 제거 */
      _clearSelectionLabel() {
        if (this._selectionOverlay && DotSolarMap.map) {
          DotSolarMap.map.removeOverlay(this._selectionOverlay);
        }
        this._selectionOverlay = null;
      },

      onDefectFlyToCoordinate(payload) {
        if (payload?.lng == null || payload?.lat == null) {
          return;
        }
        if (this._flyToPending) {
          return;
        }
        this._flyToPending = true;
        DotSolarMap.focusDefectOnMap(payload, this.solarModuleLayer);
        setTimeout(() => {
          this._flyToPending = false;
        }, 200);
      },

      onShowImagesLocationEvent(eventData) {
        if (this.isProcessingFiles) {
          console.log('File processing in progress, ignoring show-images-location event');
          return;
        }
        this.currentImageSortOrder = eventData?.sortOrder || 'time';
        this.openFileDialog();
      },
      /** 맵 관련 오류를 GlobalAlert(commonAlert)로 표시 ($toast 플러그인 미사용) */
      notifyMapAlert({ type, message, timeout }) {
        this.$store.dispatch('commonAlert/addAlert', {
          type,
          message,
          timeout: timeout ?? (type === 'error' ? 0 : 6000)
        });
      },
      notifyMapError(message) {
        this.notifyMapAlert({ type: 'error', message, timeout: 6000 });
      },
      buildMarkerSavedMessage(detail) {
        const base = this.$t('defects.mapMarkerSaved');
        // Spring Data REST HAL 응답: solarModule 은 _embedded.solarModule 에 있음
        const sm = detail?.solarModule ?? detail?._embedded?.solarModule ?? null;
        const moduleId = sm?.moduleId ?? null;
        if (moduleId) {
          return `${base} ${this.$t('defects.mapMarkerModuleLinked', { moduleId })}`;
        }
        return `${base} ${this.$t('defects.mapMarkerNoModule')}`;
      },

      /**
       * 모듈 결함 WFS 레이어 + AI 레이어 갱신.
       * origin/main과 동일: 필터가 있으면 필터 id들, 없으면 로드된 상위 결함 유형 전체 id를 defect_codes로 전달.
       * id만 없고 HAL self 링크만 있는 항목은 resolveDefectTypeRowId 로 보완.
       * 짧은 간격 연속 호출(loadDefectMarkers + requestMapRefresh + getSite 등)은 한 번으로 합친다.
       * @param {{ reason?: string, source?: string, extra?: Record<string, unknown> }} [trigger]
       */
      async refreshModuleDefectLayer(trigger = {}) {
        const reason = trigger.reason ?? SyncReason.UNKNOWN;
        const source = trigger.source ?? 'DotSolarMapBox.refreshModuleDefectLayer';
        if (!this.getReportId) {
          console.log('[DEFECT-MAP-DEBUG] refreshModuleDefectLayer skip: no getReportId');
          return;
        }
        const ex = trigger.extra && typeof trigger.extra === 'object' ? { ...trigger.extra } : {};
        const correlationId =
          ex.correlationId != null ? ex.correlationId : nextPipelineCorrelationId();
        recordSyncIntent({
          reportId: this.getReportId,
          reason,
          source,
          extra: { debounceMs: 100, correlationId, ...ex }
        });
        const seq = ++this.refreshDefectLayerSeq;
        clearTimeout(this.refreshDefectLayerTimer);
        return new Promise(resolve => {
          this.refreshDefectLayerTimer = setTimeout(async () => {
            this.refreshDefectLayerTimer = null;
            if (seq !== this.refreshDefectLayerSeq) {
              resolve();
              return;
            }
            this.$store.commit('dashboard/setWfsDefectRowsLoading', true);
            logModuleListDebug('map.wfsRefresh.start', { reason, source });
            try {
              await this.runRefreshModuleDefectLayerCore({ correlationId });
            } finally {
              this.$store.commit('dashboard/setWfsDefectRowsLoading', false);
              resolve();
            }
          }, 100);
        });
      },
      async runRefreshModuleDefectLayerCore(runOpts = {}) {
        await refreshReportDefectLayerFull({
          correlationId: runOpts.correlationId,
          reportId: this.getReportId,
          layerSeq: this.refreshDefectLayerSeq,
          source: 'DotSolarMapBox.runRefreshModuleDefectLayerCore',
          wfsContext: {
            defectFilters: this.defectFilters,
            defectTypes: this.defectTypes,
            fetchParentDefectTypes: () => defectTypeApi.getParentDefectTypes(),
            resolveDefectTypeRowId,
            resetDefectStyleDebugLogFn: resetDefectStyleDebugLog,
            getReportId: () => this.getReportId,
            getShowAiDefectFlag: () => this.getShowAiDefectFlag,
            setDefectTypes: types => {
              this.defectTypes = types;
            }
          }
        });
        await this.prefetchSolarModuleLayer();
        await this.syncModuleListMapAfterDefectRefresh();
      },

      /** 결함 WFS 갱신 후 — drawer 트리·펼침 상태는 유지, 지도만 동기화 */
      async syncModuleListMapAfterDefectRefresh() {
        this._logMapLayerDebug('syncModuleListMapAfterDefectRefresh 진입');
        logModuleListDebug('map.afterDefectRefresh', {
          wfsDefects: summarizeDefectModuleLinkage(
            this.$store.state.dashboard?.wfsDefectRows || []
          ),
          storeHierarchy: summarizeHierarchyTree(
            this.$store.state.dashboard?.siteDesignModuleHierarchy
          ),
          cachedHierarchy: summarizeHierarchyTree(this.cachedModuleHierarchy)
        });
        if (!this.moduleListOpen) {
          this.syncMapLayers();
          return;
        }
        await this.ensureSolarModuleLayerPrefetched();
        if (
          !this.$store.state.dashboard?.siteDesignModuleHierarchy?.length &&
          this.cachedModuleHierarchy?.length
        ) {
          this.$store.commit(
            'dashboard/setSiteDesignModuleHierarchy',
            this.cachedModuleHierarchy
          );
        }
        this.applyModuleDefectColors();
        const highlight = this.$store.state.dashboard?.mapHighlightTarget;
        if (highlight) {
          this.applyTreeHighlight(highlight);
        }
        this.syncMapLayers();
        this._logMapLayerDebug('syncModuleListMapAfterDefectRefresh 완료');
      },

      /**
       * WFS 결함·AI 레이어 비동기 로드 완료 후 visible 재적용.
       * 삭제 등으로 레이어가 통째로 교체될 때 syncMapLayers가 로드 전에만 호출되면 마커가 안 보일 수 있음.
       */
      async onMapDefectLayerReady(payload) {
        this.$store.commit('dashboard/setWfsDefectRowsLoading', false);
        this._logMapLayerDebug('map-defect-layer-ready', payload || {});
        logModuleListDebug('map.wfsLayerReady', {
          moduleListOpen: this.moduleListOpen,
          payload,
          wfsDefects: summarizeDefectModuleLinkage(
            this.$store.state.dashboard?.wfsDefectRows || []
          )
        });
        if (this.moduleListOpen) {
          const storeHierarchy = this.$store.state.dashboard?.siteDesignModuleHierarchy;
          const siteDesignLoading = this.$store.state.dashboard?.siteDesignLoading;
          if (storeHierarchy?.length) {
            logModuleListDebug('map.wfsLayerReady.hierarchy', { action: 'keep-store' });
          } else if (siteDesignLoading || this._solarModuleLayerPrefetchPromise) {
            logModuleListDebug('map.wfsLayerReady.hierarchy', {
              action: 'defer-enrich-siteDesign-pending',
              siteDesignLoading: !!siteDesignLoading,
              prefetchInFlight: !!this._solarModuleLayerPrefetchPromise
            });
          } else if (this.cachedModuleHierarchy?.length) {
            this.$store.commit(
              'dashboard/setSiteDesignModuleHierarchy',
              this.cachedModuleHierarchy
            );
            logModuleListDebug('map.wfsLayerReady.hierarchy', {
              action: 'restore-cached',
              ...summarizeHierarchyTree(this.cachedModuleHierarchy)
            });
          } else {
            await this.enrichDefectRowsModuleHierarchy();
          }
        }
        this.syncMapLayers();
        this.$nextTick(() => {
          this.runDefectModuleGeoVerifyIfReady('map-defect-layer-ready');
        });
      },
      onMapDefectLayerError(payload) {
        this.$store.commit('dashboard/setWfsDefectRowsLoading', false);
        logModuleListDebug('map.wfsLayerError', payload || {});
      },
      onMapAiDefectLayerReady(payload) {
        this._logMapLayerDebug('map-ai-defect-layer-ready', payload || {});
        this.syncMapLayers();
      },

      /**
       * 사용자 의도(markersWanted, showAiDefectFlag, moduleListOpen) → 레이어 visible 단일 동기화.
       * 마커 ON/OFF는 확정·AI 마커 레이어의 모든 피처를 함께 기준으로 처리한다.
       */
      syncMapLayers() {
        const defectLayer = DotSolarMap.workingLayer?.defectFeature;
        const aiLayer = DotSolarMap.workingLayer?.aiDetectFeature;
        const moduleLayer = this.solarModuleLayer;
        const before = {
          defect: defectLayer?.getVisible?.() ?? null,
          ai: aiLayer?.getVisible?.() ?? null,
          module: moduleLayer?.getVisible?.() ?? null
        };
        DotSolarMap.applyConfirmedDefectMarkerLayerVisibility(this.defectLayerVisible);
        DotSolarMap.applyAiDefectMarkerLayerVisibility(
          this.aiLayerVisible,
          this.getReportId
        );
        if (moduleLayer) {
          moduleLayer.setVisible(this.moduleLayerVisible);
        }
        DotSolarMap.map?.render();
        this._logMapLayerDebug('syncMapLayers 적용', {
          computed: {
            defectLayerVisible: this.defectLayerVisible,
            aiLayerVisible: this.aiLayerVisible,
            moduleLayerVisible: this.moduleLayerVisible
          },
          before,
          after: {
            defect: defectLayer?.getVisible?.() ?? null,
            ai: aiLayer?.getVisible?.() ?? null,
            module: moduleLayer?.getVisible?.() ?? null
          }
        });
      },

      /**
       * 지도 레이어·토글 상태 추적용 디버그 로그.
       * 콘솔 필터: [MAP-LAYER-DEBUG]
       */
      _logMapLayerDebug(event, extra = {}) {
        if (!isAppDebugEnabled()) {
          return;
        }
        const defectLayer = DotSolarMap.workingLayer?.defectFeature;
        const aiLayer = DotSolarMap.workingLayer?.aiDetectFeature;
        const moduleLayer = this.solarModuleLayer;
        const hierarchy = this.$store.state.dashboard?.siteDesignModuleHierarchy;
        logExpandedDebug('[MAP-LAYER-DEBUG]', event, {
          intent: {
            markersWanted: this.markersWanted,
            moduleListOpen: this.moduleListOpen,
            showAiDefectFlag: this.getShowAiDefectFlag,
            aiDefectLoading: this.getAiDefectLoading,
            moduleListLoading: this.moduleListLoading,
            editingMapFlag: this.editingMapFlag
          },
          computed: {
            defectLayerVisible: this.defectLayerVisible,
            aiLayerVisible: this.aiLayerVisible,
            moduleLayerVisible: this.moduleLayerVisible
          },
          layers: {
            defectFeature: {
              exists: !!defectLayer,
              visible: defectLayer?.getVisible?.() ?? null
            },
            aiDetectFeature: {
              exists: !!aiLayer,
              visible: aiLayer?.getVisible?.() ?? null
            },
            solarModuleLayer: {
              exists: !!moduleLayer,
              visible: moduleLayer?.getVisible?.() ?? null,
              siteId: this.solarModuleLayerSiteId,
              featureCount:
                moduleLayer?.getSource?.()?.getFeatures?.()?.length ?? 0
            }
          },
          drawer: {
            hierarchyRootCount: Array.isArray(hierarchy) ? hierarchy.length : 0
          },
          ...extra
        });
      },

      toggleDefectMarkers() {
        const next = !this.markersWanted;
        this._logMapLayerDebug('버튼 클릭: 마커 on/off', {
          from: this.markersWanted,
          to: next
        });
        this.markersWanted = next;
      },

      toggleModuleList() {
        if (this.moduleListLoading) {
          this._logMapLayerDebug('버튼 클릭: 모듈리스트 — 로딩 중이라 무시');
          return;
        }
        const next = !this.moduleListOpen;
        this._logMapLayerDebug('버튼 클릭: 모듈리스트', {
          from: this.moduleListOpen,
          to: next
        });
        this.$store.commit('dashboard/setDefectDrawerOpen', next);
      },

      _resolveModuleClickFromMapEvent(evt) {
        const layerFilter = layer => DotSolarMap.hitTestLayerFilter(layer);
        const topFeature = DotSolarMap.map.forEachFeatureAtPixel(evt.pixel, f => f, { layerFilter });

        if (topFeature) {
          const clickKind = classifyMapFeatureClick(topFeature);
          // 결함 마커 클릭 — 팝업/편집은 DotSolarMap singleclick 에 맡기고 모듈 선택은 하지 않음
          if (clickKind === MAP_FEATURE_CLICK_KIND.DEFECT) {
            return null;
          }
          if (clickKind === MAP_FEATURE_CLICK_KIND.MODULE) {
            const props = topFeature.getProperties();
            const featureId = topFeature.getId?.()?.toString?.() || '';
            return {
              resolution: 'featureHit',
              featureId,
              props,
              solarModuleSeq: props.solar_module_seq ?? props.module_id
            };
          }
        }

        const [lon, lat] = evt.coordinate || [];
        const cache = this._allModuleFeaturesCache || [];
        const coordinateMatch = findSolarModuleAtCoordinate(lon, lat, cache);
        if (!coordinateMatch) {
          logModuleListSync('map.click:miss', {
            lon,
            lat,
            topFeatureId: topFeature?.getId?.()?.toString?.() ?? null,
            topFeatureKind: topFeature ? classifyMapFeatureClick(topFeature) : null,
            featureCacheCount: cache.length
          });
          return null;
        }

        return {
          resolution: coordinateMatch.resolution,
          featureId: `solar_module_${coordinateMatch.solarModuleSeq}`,
          props: coordinateMatch,
          solarModuleSeq: coordinateMatch.solarModuleSeq,
          overlappingModuleCount: coordinateMatch.overlappingModuleCount
        };
      },

      _applyModuleClickFromMap({ props, solarModuleSeq, featureId, resolution }) {
        const wfsDefects = this.$store.state.dashboard?.wfsDefectRows || [];
        const matchedDefects = wfsDefects.filter(
          d => d?.solarModuleSeq != null && String(d.solarModuleSeq) === String(solarModuleSeq)
        );

        logModuleListSync('map.click:module', {
          solarModuleSeq,
          module_id: props.module_id,
          string_id: props.string_id,
          array_id: props.array_id,
          solar_string_seq: props.solar_string_seq,
          solar_array_seq: props.solar_array_seq,
          featureId,
          resolution,
          featureCacheCount: this._allModuleFeaturesCache?.length ?? 0,
          wfsDefects: summarizeDefectModuleLinkage(wfsDefects),
          defectsOnClickedModule: matchedDefects.length,
          matchedDefectSeqs: matchedDefects.slice(0, 5).map(d => d.seq)
        });

        if (solarModuleSeq == null) {
          logModuleListSync('map.click:abort', { reason: 'missingSolarModuleSeq' });
          return;
        }

        const highlightTarget = {
          kind: 'panel_single',
          seq: solarModuleSeq,
          displayId: props.module_id,
          arrayDisplayId: props.array_id,
          stringDisplayId: props.string_id,
          arraySeq: props.solar_array_seq,
          stringSeq: props.solar_string_seq
        };
        DotSolarMap.dismissMapFeaturePopup();
        this.$store.commit('dashboard/setMapHighlightTarget', highlightTarget);
        logModuleListSync('map.click:commitHighlight', { highlightTarget, resolution });
        this.$eventBus.$emit('dashboard-focus-module-defects', { solarModuleSeq });
        this.$store.commit('dashboard/setModuleClickTarget', {
          solarModuleSeq,
          timestamp: Date.now()
        });
      },

      _bindModuleClickHandler() {
        if (!DotSolarMap.map || this._moduleClickHandler) {
          return;
        }
        this._moduleClickHandler = evt => {
          if (!this.moduleListOpen) {
            logModuleListSync('map.click:ignored', { reason: 'moduleListClosed' });
            return;
          }
          const resolved = this._resolveModuleClickFromMapEvent(evt);
          if (!resolved) {
            return;
          }
          this._applyModuleClickFromMap(resolved);
        };
        DotSolarMap.map.on('singleclick', this._moduleClickHandler);
        this._detachModuleClickHandler = () => {
          if (this._moduleClickHandler && DotSolarMap.map) {
            DotSolarMap.map.un('singleclick', this._moduleClickHandler);
          }
          this._moduleClickHandler = null;
          this._detachModuleClickHandler = null;
        };
      },

      /**
       * 모듈 리스트 열기 전 확정 결함 WFS가 비어 있으면 로드 완료까지 대기
       */
      async ensureWfsDefectRowsForModuleList() {
        if (!this.getReportId) {
          logModuleListDebug('map.ensureWfs.skip', { reason: 'no reportId' });
          return;
        }
        const reportId = this.getReportId;
        const rows = this.$store.state.dashboard?.wfsDefectRows || [];
        const loadedReportId = this.$store.state.dashboard?.wfsDefectRowsReportId;
        const loading = this.$store.state.dashboard?.wfsDefectRowsLoading;
        const wfsReadyForReport =
          rows.length > 0 &&
          loadedReportId != null &&
          String(loadedReportId) === String(reportId) &&
          !loading;
        if (wfsReadyForReport) {
          logModuleListDebug('map.ensureWfs.skip', {
            reason: 'already loaded',
            count: rows.length,
            reportId,
            loadedReportId
          });
          return;
        }
        logModuleListDebug('map.ensureWfs.start', {
          existingCount: rows.length,
          loading
        });
        if (!loading) {
          await this.refreshModuleDefectLayer({
            reason: SyncReason.MODULE_LIST_OPEN,
            source: 'ensureWfsDefectRowsForModuleList'
          });
        }
        await this.waitForWfsDefectLayerReady();
        logModuleListDebug('map.ensureWfs.done', {
          count: this.$store.state.dashboard?.wfsDefectRows?.length ?? 0
        });
      },

      waitForWfsDefectLayerReady(timeoutMs = 20000) {
        const hasRows = () => {
          const loading = this.$store.state.dashboard?.wfsDefectRowsLoading;
          return !loading;
        };
        if (hasRows()) {
          return Promise.resolve();
        }
        return new Promise(resolve => {
          let settled = false;
          const finish = (reason) => {
            if (settled) return;
            settled = true;
            cleanup();
            if (reason === 'timeout') {
              this.$store.commit('dashboard/setWfsDefectRowsLoading', false);
            }
            logModuleListDebug('map.waitWfs.resolved', { reason });
            resolve();
          };
          const timer = setTimeout(() => finish('timeout'), timeoutMs);
          const onReady = () => {
            if (hasRows()) finish('map-defect-layer-ready');
          };
          const onError = () => finish('map-defect-layer-error');
          const unsub = this.$store.subscribe(mutation => {
            if (
              mutation.type === 'dashboard/setWfsDefectRowsLoading' &&
              mutation.payload === false
            ) {
              finish('wfsDefectRowsLoading-false');
            }
          });
          const cleanup = () => {
            clearTimeout(timer);
            unsub();
            this.$eventBus.$off('map-defect-layer-ready', onReady);
            this.$eventBus.$off('map-defect-layer-error', onError);
          };
          this.$eventBus.$on('map-defect-layer-ready', onReady);
          this.$eventBus.$on('map-defect-layer-error', onError);
          onReady();
        });
      },

      async enrichDefectRowsModuleHierarchy() {
        if (this._enrichDefectHierarchyPromise) {
          logModuleListDebug('map.enrich.reuse', { reason: 'in-flight' });
          return this._enrichDefectHierarchyPromise;
        }

        const run = async () => {
          const defects = this.$store.state.dashboard?.wfsDefectRows || [];
          const storeHierarchy = this.$store.state.dashboard?.siteDesignModuleHierarchy;
          logModuleListDebug('map.enrich.start', {
            defectCount: defects.length,
            linkage: summarizeDefectModuleLinkage(defects),
            beforeSample: summarizeDefectHierarchySample(defects, 5),
            cachedHierarchyRootCount: this.cachedModuleHierarchy?.length ?? 0,
            storeHierarchyRootCount: storeHierarchy?.length ?? 0,
            siteDesignLoading: !!this.$store.state.dashboard?.siteDesignLoading
          });
          if (!defects.length) {
            logModuleListDebug('map.enrich.skip', { reason: 'wfsDefectRows empty' });
            return;
          }

          const siteDesignHierarchy =
            storeHierarchy?.length ? storeHierarchy : this.cachedModuleHierarchy || [];
          const { rows, changed, hierarchy } = await enrichWfsDefectRowsFromSolarModules(defects, {
            siteDesignHierarchy
          });

          if (changed) {
            this.$store.commit('dashboard/setWfsDefectRows', rows);
            logModuleListDebug('map.enrich.storeUpdated', {
              afterSample: summarizeDefectHierarchySample(rows, 5)
            });
          }

          const commitDecision = resolveEnrichHierarchyCommit({
            storeHierarchy: this.$store.state.dashboard?.siteDesignModuleHierarchy,
            candidateHierarchy: hierarchy,
            cachedHierarchy: this.cachedModuleHierarchy
          });
          logModuleListDebug('map.enrich.hierarchyDecision', commitDecision);

          if (hierarchy?.length && commitDecision.commit) {
            this.cachedModuleHierarchy = hierarchy;
            this.$store.commit('dashboard/setSiteDesignModuleHierarchy', hierarchy);
            logModuleListDebug('map.enrich.hierarchyCommitted', {
              source: 'solarModulesApi',
              ...summarizeHierarchyTree(hierarchy)
            });
          } else if (hierarchy?.length) {
            logModuleListDebug('map.enrich.hierarchySkipped', {
              reason: commitDecision.reason,
              candidate: summarizeHierarchyTree(hierarchy),
              store: summarizeHierarchyTree(
                this.$store.state.dashboard?.siteDesignModuleHierarchy
              ),
              cached: summarizeHierarchyTree(this.cachedModuleHierarchy)
            });
          } else {
            logModuleListDebug('map.enrich.hierarchyEmpty', {
              reason: 'API returned no module infos — Array/String ? 가능'
            });
          }
        };

        this._enrichDefectHierarchyPromise = run().finally(() => {
          this._enrichDefectHierarchyPromise = null;
        });
        return this._enrichDefectHierarchyPromise;
      },

      async _runApplyModuleListState(open) {
        const token = ++this.moduleListApplyToken;
        this.moduleListLoading = true;
        try {
          if (open && (!DotSolarMap.map || !this.getReportId)) {
            logModuleListDebug('map.applyModuleListState.defer', {
              hasMap: !!DotSolarMap.map,
              reportId: this.getReportId
            });
            return;
          }
          this._logMapLayerDebug('applyModuleListState 시작', { open });
          await this.applyModuleListState(open);
          if (token === this.moduleListApplyToken) {
            this._logMapLayerDebug('watcher: moduleListOpen 처리 완료', { open });
          }
        } catch (err) {
          console.error('[DotSolarMapBox] applyModuleListState failed', err);
          this.$store.commit('dashboard/setWfsDefectRowsLoading', false);
          this.$store.commit('dashboard/setSiteDesignLoading', false);
        } finally {
          if (token === this.moduleListApplyToken) {
            this.moduleListLoading = false;
          }
        }
      },

      async applyModuleListState(open) {
        if (open) {
          await this.ensureSolarModuleLayerPrefetched();
          await this.ensureWfsDefectRowsForModuleList();
          const storeHierarchy = this.$store.state.dashboard?.siteDesignModuleHierarchy;
          const hierarchySource = storeHierarchy?.length
            ? 'siteDesignApi'
            : this.cachedModuleHierarchy?.length
              ? 'cachedHierarchy'
              : 'solarModulesApiEnrich';

          logModuleListDebug('map.applyOpen', {
            siteId: this.getSiteId,
            hasSolarModuleLayer: !!this.solarModuleLayer,
            solarModuleLayerSiteId: this.solarModuleLayerSiteId,
            featureCacheCount: this._allModuleFeaturesCache?.length ?? 0,
            hierarchySource,
            storeHierarchyBefore: summarizeHierarchyTree(storeHierarchy),
            cachedHierarchy: summarizeHierarchyTree(this.cachedModuleHierarchy),
            wfsDefects: summarizeDefectModuleLinkage(
              this.$store.state.dashboard?.wfsDefectRows || []
            )
          });

          if (storeHierarchy?.length) {
            logModuleListDebug('map.applyOpen.hierarchy', { source: 'siteDesignApi-alreadyInStore' });
          } else if (this.cachedModuleHierarchy?.length) {
            this.$store.commit(
              'dashboard/setSiteDesignModuleHierarchy',
              this.cachedModuleHierarchy
            );
            logModuleListDebug('map.applyOpen.hierarchy', {
              source: 'cachedHierarchy-restored',
              ...summarizeHierarchyTree(this.cachedModuleHierarchy)
            });
          } else {
            await this.enrichDefectRowsModuleHierarchy();
          }
          this.solarModuleLayer?.getSource?.()?.clear();
          this._getModuleHierarchyController().resetScopeKey();
          this._bindModuleClickHandler();
          this.applyModuleDefectColors();
          const highlight = this.$store.state.dashboard?.mapHighlightTarget;
          if (highlight) {
            this.applyTreeHighlight(highlight);
          }
          if (this.defectTypeSelectShow) {
            this.defectTypeSelectShow = false;
          }
          this._logMapLayerDebug('applyModuleListState: 열기 분기 완료', {
            hierarchyRootCount:
              this.$store.state.dashboard?.siteDesignModuleHierarchy?.length ?? 0,
            hierarchyAfterOpen: summarizeHierarchyTree(
              this.$store.state.dashboard?.siteDesignModuleHierarchy
            )
          });
        } else {
          logModuleListDebug('map.applyClose', {
            cachedHierarchyKept: this.cachedModuleHierarchy?.length ?? 0
          });
          this.$store.commit('dashboard/setSiteDesignModuleHierarchy', []);
          this._clearSelectionLabel();
          this._highlightedFeatures = null;
          this._getModuleHierarchyController().resetScopeKey();
          this.solarModuleLayer?.getSource?.()?.clear();
          this.$store.commit('dashboard/setMapHighlightTarget', null);
          this._logMapLayerDebug('applyModuleListState: 닫기 분기 완료', {
            note: 'drawer hierarchy 즉시 비움 — flash 방지',
            cachedHierarchyRootCount: this.cachedModuleHierarchy?.length ?? 0
          });
        }
        this.syncMapLayers();
        this._logMapLayerDebug('applyModuleListState 종료', { open });
      },

      removeSolarModuleLayer() {
        if (this.solarModuleLayer && DotSolarMap.map) {
          DotSolarMap.map.removeLayer(this.solarModuleLayer);
        }
        this.solarModuleLayer = null;
        this.solarModuleLayerSiteId = null;
        this._allModuleFeaturesCache = null;
        this._moduleHierarchyMapController?.clear();
        this._moduleHierarchyMapController = null;
        this._solarModuleLayerPrefetchPromise = null;
        this._enrichDefectHierarchyPromise = null;
        this.cachedModuleHierarchy = null;
        clearModuleHierarchyInfoCache();
        this.$store.commit('dashboard/setSiteDesignModuleHierarchy', []);
      },

      /**
       * 모듈 리스트 OFF일 때 siteDesign API + 피처 캐시를 미리 준비.
       * ON 토글 시 fetch 대기 없이 drawer 트리·지도 sync만 수행한다.
       */
      prefetchSolarModuleLayer() {
        const siteId = this.getSiteId;
        this._logMapLayerDebug('prefetchSolarModuleLayer 진입', { siteId });
        if (!siteId || !DotSolarMap.map) {
          this._logMapLayerDebug('prefetchSolarModuleLayer 중단 — siteId/map 없음');
          return Promise.resolve();
        }

        const siteKey = String(siteId);
        if (
          this.solarModuleLayerSiteId != null &&
          String(this.solarModuleLayerSiteId) === siteKey
        ) {
          this._logMapLayerDebug('prefetchSolarModuleLayer — 캐시 히트 (레이어 유무 무관)', {
            hasLayer: !!this.solarModuleLayer,
            hierarchyRootCount: this.cachedModuleHierarchy?.length ?? 0
          });
          this._warmModuleLayerStylesOffscreen();
          return Promise.resolve();
        }

        if (this._solarModuleLayerPrefetchPromise) {
          this._logMapLayerDebug('prefetchSolarModuleLayer — 진행 중인 promise 재사용');
          return this._solarModuleLayerPrefetchPromise;
        }

        this._logMapLayerDebug('prefetchSolarModuleLayer — showSolarModuleLayer 시작');
        this._solarModuleLayerPrefetchPromise = this.showSolarModuleLayer()
          .then(() => {
            this._warmModuleLayerStylesOffscreen();
            this._logMapLayerDebug('prefetchSolarModuleLayer 완료');
          })
          .catch(err => {
            console.warn('[DotSolarMapBox] prefetchSolarModuleLayer failed', err);
            this._logMapLayerDebug('prefetchSolarModuleLayer 실패', { error: String(err) });
          })
          .finally(() => {
            this._solarModuleLayerPrefetchPromise = null;
          });

        return this._solarModuleLayerPrefetchPromise;
      },

      async ensureSolarModuleLayerPrefetched() {
        this._logMapLayerDebug('ensureSolarModuleLayerPrefetched 진입');
        if (this._solarModuleLayerPrefetchPromise) {
          this._logMapLayerDebug('ensureSolarModuleLayerPrefetched — promise 대기');
          await this._solarModuleLayerPrefetchPromise;
          return;
        }
        const siteId = this.getSiteId;
        const siteKey = siteId != null ? String(siteId) : null;
        const alreadyLoadedForSite =
          siteKey &&
          this.solarModuleLayerSiteId != null &&
          String(this.solarModuleLayerSiteId) === siteKey;
        if (!alreadyLoadedForSite && siteId) {
          this._logMapLayerDebug('ensureSolarModuleLayerPrefetched — siteDesign 미조회, prefetch 호출');
          await this.prefetchSolarModuleLayer();
        } else {
          this._logMapLayerDebug('ensureSolarModuleLayerPrefetched — 이미 조회됨', {
            hasLayer: !!this.solarModuleLayer,
            hierarchyRootCount: this.cachedModuleHierarchy?.length ?? 0
          });
        }
      },

      /** source가 비어 있어도 캐시 피처에 결함 색상을 미리 계산 (OFF 상태 prefetch) */
      _warmModuleLayerStylesOffscreen() {
        if (!this._allModuleFeaturesCache?.length) {
          return;
        }
        this._getModuleHierarchyController().setFeatureCache(this._allModuleFeaturesCache);
        this.applyModuleDefectColors();
      },

      // Solar Module 레이어 표시 (siteDesign API → OL Feature 직접 빌드)
      async showSolarModuleLayer() {
        let startedSiteDesignLoading = false;
        const siteId = this.getSiteId;
        this._logMapLayerDebug('showSolarModuleLayer 시작', { siteId });
        try {
          if (!siteId) {
            console.warn('[DotSolarMapBox] Solar Module 레이어: siteId 없음');
            this._logMapLayerDebug('showSolarModuleLayer 중단 — siteId 없음');
            return;
          }

          const siteKey = String(siteId);
          if (
            this.solarModuleLayerSiteId != null &&
            String(this.solarModuleLayerSiteId) === siteKey
          ) {
            this._logMapLayerDebug('showSolarModuleLayer — 이미 조회된 site, 스킵', {
              hasLayer: !!this.solarModuleLayer
            });
            return;
          }

          const needsReload =
            this.solarModuleLayer &&
            this.solarModuleLayerSiteId != null &&
            String(this.solarModuleLayerSiteId) !== siteKey;

          // 기존 WFS 레이어가 남아있으면 제거 (siteDesign API로 전환)
          if (this.solarModuleLayer && this.solarModuleLayerSiteId == null) {
            this.removeSolarModuleLayer();
          }

          if (needsReload) {
            this.removeSolarModuleLayer();
          }

          const willFetch = !this.solarModuleLayer;
          if (willFetch) {
            this.$store.commit('dashboard/setSiteDesignLoading', true);
            startedSiteDesignLoading = true;
          }

          if (!this.solarModuleLayer) {
            const oldLayer = DotSolarMap.getLayer(DotSolarMap.map, 'solar-module-layer');
            if (oldLayer) {
              DotSolarMap.map.removeLayer(oldLayer);
            }

            const layerResult = await buildModulePolygonLayer({
              siteId,
              style: DotMapStyle.solarModule
            });
            const { layer, hierarchy, features: allFeatures } = layerResult;

            this.cachedModuleHierarchy = hierarchy;
            if (this.moduleListOpen) {
              this.$store.commit('dashboard/setSiteDesignModuleHierarchy', hierarchy);
              logModuleListDebug('map.siteDesign.hierarchyCommitted', {
                source: 'siteDesignApi',
                ...summarizeHierarchyTree(hierarchy)
              });
            }
            this._logMapLayerDebug('showSolarModuleLayer — siteDesign 반영', {
              siteId,
              layerCreated: !!layer,
              featureCount: allFeatures?.length ?? 0,
              hierarchyRootCount: hierarchy?.length ?? 0
            });

            if (layer) {
              this.solarModuleLayer = layer;
              this.solarModuleLayerSiteId = siteId;
              layer.set('name', 'solar-module-layer');
              layer.setZIndex(DotSolarMap.solarModuleZindex);
              layer.setVisible(false);
              DotSolarMap.map.addLayer(layer);

              this._allModuleFeaturesCache = [...allFeatures];
              this._getModuleHierarchyController().setFeatureCache(allFeatures);
              layer.getSource()?.clear();

              if (!allFeatures.length) {
                this._logMapLayerDebug('showSolarModuleLayer — siteDesign 피처 없음 (drawer는 결함 트리 폴백)', {
                  siteId
                });
              }
              this.$nextTick(() => {
                this.applyModuleDefectColors();
                DotSolarMap.map?.render();
              });

              console.log('[dashboardMap] modulePolygonLayer loaded', {
                siteId,
                totalModules: allFeatures.length,
                arrayCount: hierarchy.length
              });
            } else {
              // solarSections 없음 등 — 레이어는 없지만 조회 완료로 표시해 재요청 방지
              this.solarModuleLayerSiteId = siteId;
              this._allModuleFeaturesCache = [];
              this._logMapLayerDebug('showSolarModuleLayer — 빈 siteDesign (재요청 캐시)', {
                siteId
              });
            }
          } else {
            this.solarModuleLayer.setZIndex(DotSolarMap.solarModuleZindex);
            this.solarModuleLayer.setVisible(false);
          }
        } catch (error) {
          console.error('Solar Module 레이어 표시 중 오류:', error);
          this._logMapLayerDebug('showSolarModuleLayer 오류', { error: String(error) });
          this.$store.commit('dashboard/setDefectDrawerOpen', false);
        } finally {
          if (startedSiteDesignLoading) {
            this.$store.commit('dashboard/setSiteDesignLoading', false);
          }
          this._logMapLayerDebug('showSolarModuleLayer 종료', { siteId });
        }
      },

      // Solar Module 레이어 숨기기
      hideSolarModuleLayer() {
        if (this.solarModuleLayer) {
          this.solarModuleLayer.setVisible(false);
          console.log('Solar Module 레이어가 숨겨졌습니다.');
        }
      },
      // 지도 초기화 메서드
      initializeMap() {
        // 지도 초기 랜더링
        DotSolarMap.initMap('map', {
          //태양광
          zoom: 19.09898572944446,
          drawingOn: false, // enable to draw a polygon on map
          // 화면에 표시할 맵을 선택한다.
          mapsOn: {
            baseOn: false,
            satelliteOn: true
          }
        });

        DotSolarMap.initOverlayPopup(
          'map-popup',
          'map-popup-content',
          'map-popup-closer',
          'ol-popup-img-wrapper',
          'ol-popup-canvas',
          'ol-popup-content-table'
        );

        DotSolarMap.setMapEditable(this.editingMapFlag);
      },

      /**
       * 부모 결함 유형 로드 후 refreshModuleDefectLayer 로 WFS 갱신.
       * @param {{ source?: string }} [options] — mounted / route 복귀 등 호출 구분
       */
      loadDefectMarkers(options = {}) {
        const callerSource = options.source ?? 'loadDefectMarkers';
        recordSyncIntent({
          reportId: this.getReportId,
          reason: SyncReason.LOAD_DEFECT_MARKERS,
          source: `${callerSource}.parentTypesFetchStart`,
          extra: { phase: 'start' }
        });
        defectTypeApi
          .getParentDefectTypes()
          .then(data => {
            const raw = data?._embedded?.defectTypes;
            this.defectTypes = Array.isArray(raw) ? raw : [];
            console.log('[DEFECT-MAP-DEBUG] loadDefectMarkers parentTypes', {
              count: this.defectTypes.length,
              embeddedKeys: data && typeof data === 'object' ? Object.keys(data) : [],
              first: this.defectTypes[0]
                ? {
                    id: this.defectTypes[0].id,
                    seq: this.defectTypes[0].seq,
                    name: this.defectTypes[0].name
                  }
                : null
            });
          })
          .then(() =>
            this.refreshModuleDefectLayer({
              reason: SyncReason.LOAD_DEFECT_MARKERS,
              source: 'loadDefectMarkers.afterParentTypes',
              extra: { parentLoadSource: callerSource }
            })
          )
          .catch(err => {
            console.error('[DotSolarMapBox] loadDefectMarkers 실패:', err);
            console.log(
              '[DEFECT-MAP-DEBUG] loadDefectMarkers error, still calling refreshModuleDefectLayer'
            );
            return this.refreshModuleDefectLayer({
              reason: SyncReason.LOAD_DEFECT_MARKERS,
              source: 'loadDefectMarkers.afterError',
              extra: { loadError: true, parentLoadSource: callerSource }
            });
          });
      },

      // 결함 목록 갱신 메서드
      async fetchDefects() {
        await this.refreshModuleDefectLayer({
          reason: SyncReason.FETCH_DEFECTS_LIST,
          source: 'fetchDefects'
        });

        // 결함 요약 정보 갱신
        this.getDefectSummary(this.getReportId);
      },

      /** AI 중복 검출 제거 다이얼로그에서 결함 삭제 후 지도·요약 동기화 */
      onAiDuplicateDefectsRemoved() {
        if (!this.getReportId) return;
        if (this.getShowAiDefectFlag) {
          DotSolarMap.fetchAiDetectDefectLocation(this.getReportId);
        }
        this.getDefectSummary(this.getReportId);
      },

      /** AI 중복검출 자동 그룹 검토에서 숨김 적용/해제 — 지도 마커 즉시 반영 */
      onAiDedupApplied() {
        if (!this.getReportId) return;
        DotSolarMap.applyAiDefectDedupHiddenForReport(this.getReportId);
      },

      /** AI 중복검출 — 서버 삭제 후 지도·요약 갱신 */
      onAiDedupDeleted() {
        if (!this.getReportId) return;
        if (this.getShowAiDefectFlag) {
          DotSolarMap.fetchAiDetectDefectLocation(this.getReportId);
        }
        DotSolarMap.applyAiDefectDedupHiddenForReport(this.getReportId);
        this.getDefectSummary(this.getReportId);
      },

      async toggleAndFetchData() {
        this.$store.commit('dashboard/SET_AI_DEFECT_LOADING', true);
        try {
          await this.toggleAndFetchThermalData(this.getShowAiDefectFlag);
        } finally {
          this.$store.commit('dashboard/SET_AI_DEFECT_LOADING', false);
        }
      },
      CloseImageLocationDialog() {
        this.imageLocationDialog = false;
      },
      showImageLocations() {
        // 파일 처리 중이면 무시
        if (this.isProcessingFiles) {
          console.log('File processing in progress, ignoring showImageLocations call');
          return 0;
        }

        // 로딩 상태 시작
        this.isProcessingFiles = true;

        // 파일 선택 대화상자 열기
        this.openFileDialog();
      },
      /** 맵 툴바 PNG: 라이트 비활성은 슬레이트 톤 실루엣(CSS), 활성·다크는 원본 */
      mapToolbarRasterClass(isActive) {
        return [
          'map-toolbar-raster',
          this.$vuetify.theme.dark ? 'map-toolbar-raster--dark' : 'map-toolbar-raster--light',
          { 'map-toolbar-raster--active': !!isActive }
        ];
      },
      /** 라이트·보라 배경 토글: 아이콘 흰색용 클래스 (다크는 미적용) */
      mapToolbarToggleBtnClass(isActive, variant = 'primary') {
        return mapToolbarBtnStateClasses(this.$vuetify, isActive, variant);
      },
      /** primary 토글 공통 — 보라 채움 + inset 눌림 + OFF elevation */
      mapToolbarPressedToggleBtnProps(isActive, extra = {}) {
        const { loading = false, ...rest } = extra;
        return resolveMapToolbarPressedToggleBtnProps(this.$vuetify, {
          active: isActive,
          loading,
          extra: rest
        });
      },
      /** @deprecated mapToolbarPressedToggleBtnProps 사용 */
      mapToolbarToggleBtnStyle(isActive) {
        return resolveMapToolbarToggleBtnStyle(this.$vuetify, isActive);
      },
      mapToolbarActiveStyle(isActive) {
        return resolveMapToolbarActiveStyle(this.$vuetify, isActive);
      },
      mapToolbarToggleIconColor(isActive) {
        return resolveMapToolbarToggleIconColor(this.$vuetify, isActive);
      },
      mapToolbarOnPrimaryIconColor(isActive) {
        return resolveMapToolbarOnPrimaryIconColor(this.$vuetify, isActive);
      },
      mapToolbarOnPrimaryBtnStyle(isActive) {
        return resolveMapToolbarOnPrimaryBtnStyle(this.$vuetify, isActive);
      },
      imageSrc(defectCode) {
        //require(`@/assets/image/icons/defect/${item.defectCode.toLowerCase()}.png`)
        let img = '';
        try {
          // 동적 경로로 이미지 로드 시도
          img = require(`@/assets/image/icons/defect/${defectCode.toLowerCase()}.png`);
        } catch (e) {
          console.log('이미지를 로드하는 중 오류 발생:', e);
          // 기본 이미지 경로를 지정하여 fallback
          img = '';
        }
        return img;
      },
      toggleAIButton() {
        const next = !this.isAIButtonActive;
        this._logMapLayerDebug('버튼 클릭: AI 결함', {
          from: this.isAIButtonActive,
          to: next
        });
        this.isAIButtonActive = next;
      },

      /**
       * solarModuleLayer 폴리곤에 결함 통계 기반 색상 + 모듈ID 레이블 적용.
       * 라벨은 feature 의 module_id 속성에서 읽어 중앙에 표시한다.
       */
      applyModuleDefectColors() {
        const layer = this.solarModuleLayer;
        const source = layer?.getSource?.();
        if (!source) return;

        const defects = this.$store.state.dashboard?.wfsDefectRows || [];
        const linkage = summarizeDefectModuleLinkage(defects);
        const featurePool = this._allModuleFeaturesCache?.length
          ? this._allModuleFeaturesCache
          : source.getFeatures();

        logModuleListSync('map.applyModuleDefectColors', {
          wfsCount: defects.length,
          linkage,
          featureCount: featurePool?.length ?? 0,
          deletedShouldBeGone: defects.find(d => d.seq === this._lastDeletedSeq)
            ? 'STILL_PRESENT'
            : 'OK'
        });

        const seqToModuleInfo = new Map();
        const displayKeyToModuleSeq = new Map();
        featurePool.forEach(f => {
          const moduleSeq = f.get('solar_module_seq');
          if (moduleSeq == null || moduleSeq === '') return;
          const moduleId = f.get('module_id') ?? f.get('moduleId') ?? null;
          const stringId = f.get('string_id') ?? f.get('solar_string_id') ?? null;
          const arrayId = f.get('array_id') ?? f.get('solar_array_id') ?? null;
          seqToModuleInfo.set(String(moduleSeq), {
            moduleId,
            stringSeq: f.get('solar_string_seq') ?? null,
            stringId,
            arraySeq: f.get('solar_array_seq') ?? null,
            arrayId
          });
          const displayKey = buildModuleDisplayKey({
            displayId: moduleId,
            arrayDisplayId: arrayId,
            stringDisplayId: stringId
          });
          if (displayKey) {
            displayKeyToModuleSeq.set(displayKey, moduleSeq);
          }
        });

        let needsModuleInfoCommit = false;
        let assignedSeqCount = 0;
        const defectsWithModuleInfo = defects.map(d => {
          const updated = { ...d };
          let changed = false;

          if (updated.solarModuleSeq == null || updated.solarModuleSeq === '') {
            const displayKey = buildDefectModuleDisplayKey(d);
            const inferredSeq = displayKey ? displayKeyToModuleSeq.get(displayKey) : null;
            if (inferredSeq != null) {
              updated.solarModuleSeq = inferredSeq;
              changed = true;
              assignedSeqCount += 1;
            }
          }

          const info = seqToModuleInfo.get(String(updated.solarModuleSeq));
          if (info) {
            if (!updated.moduleId && info.moduleId) { updated.moduleId = info.moduleId; changed = true; }
            if (!updated.solarStringSeq && info.stringSeq) { updated.solarStringSeq = info.stringSeq; changed = true; }
            if (!updated.stringId && info.stringId) { updated.stringId = info.stringId; changed = true; }
            if (!updated.solarArraySeq && info.arraySeq) { updated.solarArraySeq = info.arraySeq; changed = true; }
            if (!updated.arrayId && info.arrayId) { updated.arrayId = info.arrayId; changed = true; }
          }

          if (changed) needsModuleInfoCommit = true;
          return updated;
        });
        if (assignedSeqCount > 0) {
          logModuleListSync('map.applyModuleDefectColors:assignSeqFromDisplay', {
            assignedSeqCount,
            linkageAfter: summarizeDefectModuleLinkage(defectsWithModuleInfo)
          });
        }
        if (needsModuleInfoCommit) {
          logModuleListSync('map.applyModuleDefectColors:enrich', {
            before: defects.slice(0, 2).map(d => ({
              seq: d.seq,
              solarModuleSeq: d.solarModuleSeq,
              solarArraySeq: d.solarArraySeq,
              solarStringSeq: d.solarStringSeq
            })),
            after: defectsWithModuleInfo.slice(0, 2).map(d => ({
              seq: d.seq,
              solarModuleSeq: d.solarModuleSeq,
              solarArraySeq: d.solarArraySeq,
              solarStringSeq: d.solarStringSeq
            }))
          });
          validateDefectFeatures(defectsWithModuleInfo, 'DotSolarMapBox WFS response');
          this.$store.commit('dashboard/setWfsDefectRows', defectsWithModuleInfo);
        }

        const statsByModule = {};
        defectsWithModuleInfo.forEach(d => {
          const key = String(d.solarModuleSeq);
          if (!key || key === 'null' || key === 'undefined') return;
          if (!statsByModule[key]) {
            statsByModule[key] = { count: 0 };
          }
          statsByModule[key].count += 1;
        });

        const featuresInSource = source.getFeatures();
        const featuresToStyle =
          featuresInSource.length > 0
            ? featuresInSource
            : this._allModuleFeaturesCache?.length
              ? this._allModuleFeaturesCache
              : [];

        featuresToStyle.forEach(f => {
          const moduleSeq = String(f.get('solar_module_seq') ?? '');
          const stats = statsByModule[moduleSeq];
          const baseStyle = DotMapStyle.solarModuleByDefectStatus(stats);
          f.setStyle(baseStyle);
        });

        DotSolarMap.map?.render();
        this.$nextTick(() => {
          this.runDefectModuleGeoVerifyIfReady('applyModuleDefectColors');
        });
      },
      /**
       * 열화상 미리보기 hover (frontend_bu_260515): v-img 640×512 + layerX/layerY → 그리드 인덱스.
       */
      displayDegree(e) {
        const dm = this.thermalDataHolder.dataMap;
        if (!this.thermalDataHolder.isLoadingCompleted() || !dm?.length || !dm[0]?.length) {
          this.pointThermalValue = null;
          this.thermalHoverReadout = { show: false, x: 0, y: 0 };
          return;
        }
        const gridW = dm[0].length;
        const gridH = dm.length;
        const lx = Number.isFinite(e.layerX) ? e.layerX : e.offsetX;
        const ly = Number.isFinite(e.layerY) ? e.layerY : e.offsetY;
        if (!Number.isFinite(lx) || !Number.isFinite(ly)) {
          this.pointThermalValue = null;
          this.thermalHoverReadout = { show: false, x: 0, y: 0 };
          return;
        }
        const el = e.currentTarget;
        const bw = el && el.clientWidth > 0 ? el.clientWidth : THERMAL_IR_PREVIEW_IMG_W_PX;
        const bh = el && el.clientHeight > 0 ? el.clientHeight : THERMAL_IR_PREVIEW_IMG_H_PX;
        const xi = Math.min(gridW - 1, Math.max(0, Math.floor((lx / bw) * gridW)));
        const yi = Math.min(gridH - 1, Math.max(0, Math.floor((ly / bh) * gridH)));
        this.pointThermalValue = this.thermalDataHolder.getPointValue(xi, yi);

        const wrapRef = this.$refs.thermalPreviewWrap;
        const wrapEl = wrapRef && wrapRef.$el ? wrapRef.$el : wrapRef;
        if (!wrapEl || typeof wrapEl.getBoundingClientRect !== 'function') {
          this.thermalHoverReadout = { show: true, x: 0, y: 0 };
          return;
        }
        const wrect = wrapEl.getBoundingClientRect();
        this.thermalHoverReadout = {
          show: true,
          x: Math.max(0, Math.min(e.clientX - wrect.left + 10, wrect.width - 56)),
          y: Math.max(0, Math.min(e.clientY - wrect.top + 10, wrect.height - 28))
        };
      },
      onThermalPreviewMouseLeave() {
        this.pointThermalValue = null;
        this.thermalHoverReadout = { show: false, x: 0, y: 0 };
      },

      async openReportSummaryDialog() {
        await this.openReport('summary');
      },

      async openReportDetailDialog() {
        await this.openReport('detail');
      },

      /**
       * 요약/상세 보고서 생성 진입점.
       * 동일 날짜 보고서가 여러 개면 선택 다이얼로그를 띄우고, 하나면 바로 생성한다.
       * @param {'summary'|'detail'} mode 생성할 보고서 종류
       */
      async openReport(mode) {
        if (!this.getReportId) {
          this.notifyMapError(this.$t('map.toastNoReport'));
          return;
        }

        this.reportSelectionMode = mode;
        const setLoading = v => {
          if (mode === 'detail') this.reportDetailLoading = v;
          else this.reportSummaryLoading = v;
        };
        setLoading(true);

        try {
          // 동일한 날짜에 조사된 보고서들을 확인
          const response = await SolarExamineReportApi.getReportsInSameExamineDate(
            this.getReportId
          );

          if (response?.data?.content && response?.data?.content?.length > 1) {
            // 여러 보고서가 있는 경우 - 선택 다이얼로그 표시
            this.sameExamineDateReports = response.data.content;
            this.showReportSelectionDialog = true;
          } else if (mode === 'detail') {
            await this.generateReportDetail([this.getReportId]);
          } else {
            await this.generateReportSummary([this.getReportId]);
          }
        } catch (error) {
          console.error('동일 날짜 보고서 조회 실패:', error);
          this.notifyMapError(this.$t('map.toastReportListFailed'));
        } finally {
          setLoading(false);
        }
      },

      async generateReportDetail(reportIds) {
        this.reportDetailLoading = true;

        try {
          const response = await SolarExamineReportApi.getExamineReportDetail(reportIds);
          const data = response?.data;
          if (data) {
            if (data.result === 'S') {
              if (data?.content) {
                this.selectedReportIds = reportIds;
                this.reportDetailData = data.content;
                this.reportDetailDialogOpen = true;
              }
            } else {
              this.notifyMapAlert({
                type: 'error',
                message: data.resultDesc || '알 수 없는 오류',
                timeout: 0
              });
            }
          }
        } catch (error) {
          console.error('결함 상세 보고서 생성 실패:', error);
          this.notifyMapError(this.$t('map.toastReportSummaryFailed'));
        } finally {
          this.reportDetailLoading = false;
        }
      },

      async generateReportSummary(reportIds) {
        this.reportSummaryLoading = true;

        try {
          const response = await SolarExamineReportApi.getExamineReportSummary(reportIds);
          const data = response?.data;
          console.log('[SUMMARY-API] 응답:', JSON.stringify(data).slice(0, 500));
          if (data) {
            if (data.result === 'S') {
              // 성공: 알림 없이 다이얼로그만 오픈
              if (data?.content) {
                this.selectedReportIds = reportIds;
                this.reportSummaryData = data.content;
                this.reportSummaryDialogOpen = true;
              }
            } else {
              // 실패: 빨간색 알림, 사용자가 닫을 때까지 유지
              this.notifyMapAlert({
                type: 'error',
                message: data.resultDesc || '알 수 없는 오류',
                timeout: 0
              });
            }
          }
        } catch (error) {
          console.error('보고서 요약 생성 실패:', error);
          this.notifyMapError(this.$t('map.toastReportSummaryFailed'));
        } finally {
          this.reportSummaryLoading = false;
        }
      },

      onReportSelectionConfirm(selectedReportIds) {
        this.showReportSelectionDialog = false;
        if (this.reportSelectionMode === 'detail') {
          this.generateReportDetail(selectedReportIds);
        } else {
          this.generateReportSummary(selectedReportIds);
        }
      },

      onReportSelectionCancel() {
        this.showReportSelectionDialog = false;
      },

      closeReportSummaryDialog() {
        this.reportSummaryDialogOpen = false;
        this.selectedReportIds = [];
        this.reportSummaryData = null;
      },
      closeReportDetailDialog() {
        this.reportDetailDialogOpen = false;
        this.selectedReportIds = [];
        this.reportDetailData = null;
      },
      removeDefectFilter(item) {
        const targetId = resolveDefectTypeRowId(item);
        if (targetId == null) {
          this.defectFilters = this.defectFilters.filter(f => f !== item);
          return;
        }
        this.defectFilters = this.defectFilters.filter(f => resolveDefectTypeRowId(f) !== targetId);
      },
      clearDefectFilters() {
        this.defectFilters = [];
        this.defectTypeSelectShow = false;
      },
      openFileDialog() {
        // 기존 input 요소가 있다면 제거
        const existingInput = document.querySelector('input[type="file"]');
        if (existingInput) {
          existingInput.remove();
        }

        const input = document.createElement('input');
        input.type = 'file';
        input.multiple = true;
        input.accept = 'image/*';
        input.style.display = 'none'; // 화면에 보이지 않도록 설정

        // cancel 이벤트 리스너 등록 (파일 대화상자 취소 감지)
        input.addEventListener('cancel', () => {
          console.log('File dialog cancelled');
          this.isProcessingFiles = false;
          // CoreHeader에 처리 완료 알림
          this.$eventBus.$emit('image-processing-complete');
        });

        // 이벤트 핸들러를 한 번만 등록
        input.onchange = event => {
          // 파일이 선택되었을 때만 처리 (이미 isProcessingFiles는 true로 설정됨)

          try {
            const files = Array.from(event.target.files);

            if (files.length === 0) {
              console.log('No files selected');
              this.isProcessingFiles = false; // 파일 선택 취소 시 로딩 상태 해제
              // CoreHeader에 처리 완료 알림
              this.$eventBus.$emit('image-processing-complete');
              return;
            }

            DotSolarMap.prepareImageMarkerLayer();
            //마커표시

            try {
              // EXIF 분석 수행 (비동기)
              this.performExifAnalysis(files);

              ImageUtil.extractGpsPointFromImage(files, this.currentImageSortOrder, result => {
                // 결과 객체에서 데이터 추출
                const { success, validFiles, recommendImgPos, summary, processingResult } = result;

                try {
                  // GPS 좌표가 있는 파일이 있는 경우에만 지도에 표시
                  if (success && validFiles.length > 0) {
                    DotSolarMap.displayImageMark(validFiles, recommendImgPos);
                  }

                  // 처리 결과를 컴포넌트 데이터에 저장 (항상 dialog 표시)
                  this.recommendImgPos = recommendImgPos || [];
                  this.imagePosition = validFiles || [];
                  this.imageLocationSummary = summary || { median: 0, mean: 0, max: 0, min: 0 };
                  this.imageProcessingResult = processingResult || {
                    totalFiles: 0,
                    successFiles: [],
                    failedFiles: [],
                    filesWithoutGps: [],
                    filesWithoutExif: [],
                    filesWithoutDateTime: [],
                    errors: []
                  };

                  console.log('=== 이미지 처리 결과 ===');
                  console.log('성공:', success);
                  console.log('유효한 파일:', validFiles.length);
                  console.log('처리 결과:', processingResult);

                  // 항상 dialog 표시 (성공/실패 여부와 무관)
                  this.isProcessingFiles = false;
                  this.imageLocationDialog = true;

                  // CoreHeader에 처리 완료 알림
                  this.$eventBus.$emit('image-processing-complete');
                } catch (error) {
                  console.error('Error displaying image marks:', error);

                  // 에러가 발생해도 처리 결과는 표시
                  this.imageProcessingResult = processingResult || {
                    totalFiles: files.length,
                    successFiles: [],
                    failedFiles: files.map(f => f.name),
                    filesWithoutGps: [],
                    filesWithoutExif: [],
                    filesWithoutDateTime: [],
                    errors: [
                      {
                        fileName: 'Unknown',
                        error: error.message || this.$t('map.unknownError'),
                        stack: error.stack
                      }
                    ]
                  };

                  // 에러가 발생해도 dialog 표시
                  this.isProcessingFiles = false;
                  this.imageLocationDialog = true;

                  // CoreHeader에 처리 완료 알림
                  this.$eventBus.$emit('image-processing-complete');
                }
              });
            } catch (error) {
              console.error('Error calling extractGpsPointFromImage:', error);
              alert(this.$t('map.alertImageProcessError'));
              this.isProcessingFiles = false; // 에러 발생 시 로딩 상태 해제
              // CoreHeader에 처리 완료 알림
              this.$eventBus.$emit('image-processing-complete');
            }
          } catch (error) {
            console.error('Error processing files:', error);
            alert(this.$t('map.alertFileProcessError'));
            this.isProcessingFiles = false; // 에러 발생 시 로딩 상태 해제
            // CoreHeader에 처리 완료 알림
            this.$eventBus.$emit('image-processing-complete');
          } finally {
            // input 요소 제거 (로딩 상태는 이미 위에서 해제됨)

            // input 요소 제거
            if (input.parentNode) {
              input.parentNode.removeChild(input);
            }
          }
        };

        // input 요소를 DOM에 추가하고 클릭
        document.body.appendChild(input);
        input.click();
      },
      /**
       * ## 이미지 좌표 파일 선택 후  해당 파일에서 가져온 정보 summary에 표시
       */
      calculateImageDistance() {},
      handleMouseEnter() {
        this.isRgbHovered = true;
        this.tooltipVisible = false; // 버튼 hover 시 tooltip 숨김
      },
      handleMouseLeave() {
        this.isRgbHovered = false;
        this.tooltipVisible = true; // 버튼 hover 해제 시 tooltip 표시
      },
      getDefectSummary(reportId) {
        return this.fetchDefectSummary(reportId);
      },
      ...mapActions({
        setSite: 'explorer/setSite',
        setReport: 'explorer/setReport',
        setReportId: 'explorer/setReportId',
        setMapMenu: 'explorer/setMapMenu',
        setReportSelectTaskComplete: 'explorer/setReportSelectTaskComplete',
        toggleAndFetchThermalData: 'dashboard/toggleAndFetchThermalData',
        setShowAiDefectFlag: 'dashboard/setShowAiDefectFlag',
        fetchDefectSummary: 'dashboard/fetchDefectSummary'
      }),
      onRgbViewButtonClick() {
        this.visibleImageOnMap = !this.visibleImageOnMap;
      },
      notifyRgbViewUnavailable() {
        this.$eventBus.$emit('alert-on', {
          on: true,
          message: this.$t('map.rgbViewUnavailable'),
          status: 'warning'
        });
      },
      hasImagePositionCoords(imgPosCoords) {
        if (!imgPosCoords) {
          return false;
        }
        if (imgPosCoords.coordinates && Array.isArray(imgPosCoords.coordinates)) {
          const ring = imgPosCoords.coordinates[0];
          return Array.isArray(ring) && ring.length > 0;
        }
        return Array.isArray(imgPosCoords) && imgPosCoords.length > 0;
      },
      resolveThermalForMapOverlay() {
        return this.thermalImage || this.getSelectedThermalImage || null;
      },
      showIrOutlineForThermal(thermal) {
        if (this.hasImagePositionCoords(thermal?.imgPosCoords)) {
          DotSolarMap.displayThermalGeoRectangle(thermal.imgPosCoords);
        } else {
          DotSolarMap.setThermalOutlineVisible(false);
        }
      },
      /**
       * IR 테두리 ↔ RGB 래스터 — 둘 중 하나만 지도에 표시.
       * visibleImageOnMap(버튼)은 사용자 의도만 반영하고, 실패 시에도 되돌리지 않는다.
       * @param {boolean} showRgb true면 RGB, false면 IR 테두리
       */
      async applyMapRgbViewMode(showRgb, viewGen) {
        const thermal = this.resolveThermalForMapOverlay();
        if (!thermal) {
          if (showRgb) {
            this.$eventBus.$emit('alert-on', {
              on: true,
              message: this.$t('map.rgbViewNeedThermal'),
              status: 'warning'
            });
          }
          DotSolarMap.showImageOnMap(false);
          DotSolarMap.setThermalOutlineVisible(false);
          return;
        }

        if (!this.hasImagePositionCoords(thermal.imgPosCoords)) {
          if (showRgb) {
            this.$eventBus.$emit('alert-on', {
              on: true,
              message: this.$t('map.rgbViewNeedThermal'),
              status: 'warning'
            });
          }
          DotSolarMap.showImageOnMap(false);
          this.showIrOutlineForThermal(thermal);
          return;
        }

        if (showRgb) {
          if (!thermal.pairRgbImageId) {
            this.notifyRgbViewUnavailable();
            DotSolarMap.showImageOnMap(false);
            this.lastMapRgbThermalId = null;
            this.showIrOutlineForThermal(thermal);
            return;
          }
          DotSolarMap.setThermalOutlineVisible(false);
          const thermalId = thermal.id != null ? Number(thermal.id) : null;
          const canReuseRgb =
            DotSolarMap.hasRgbImageOnMap() &&
            thermalId != null &&
            thermalId === this.lastMapRgbThermalId;
          if (canReuseRgb) {
            DotSolarMap.showImageOnMap(true);
            return;
          }
          const loaded = await this.loadRgbGeoImageOnMap(thermal, true);
          if (viewGen != null && viewGen !== this.rgbViewGeneration) {
            return;
          }
          if (loaded && thermalId != null) {
            this.lastMapRgbThermalId = thermalId;
            return;
          }
          this.notifyRgbViewUnavailable();
          DotSolarMap.showImageOnMap(false);
          this.showIrOutlineForThermal(thermal);
          return;
        }

        DotSolarMap.showImageOnMap(false);
        this.lastMapRgbThermalId = null;
        this.showIrOutlineForThermal(thermal);
      },
      /**
       * 선택 열화상 변경 시 IR/RGB 오버레이 동기화.
       */
      async syncMapImageOverlay(changeGen) {
        const thermal = this.thermalImage;
        if (!thermal || !this.hasImagePositionCoords(thermal.imgPosCoords)) {
          DotSolarMap.removeImageOnMap();
          DotSolarMap.setThermalOutlineVisible(false);
          this.lastMapRgbThermalId = null;
          return;
        }

        if (this.visibleImageOnMap) {
          DotSolarMap.setThermalOutlineVisible(false);
          if (!thermal.pairRgbImageId) {
            DotSolarMap.removeImageOnMap();
            this.lastMapRgbThermalId = null;
            this.notifyRgbViewUnavailable();
            this.showIrOutlineForThermal(thermal);
            return;
          }
          const loaded = await this.loadRgbGeoImageOnMap(thermal, true);
          if (changeGen !== this.changeImageGeneration) {
            return;
          }
          if (loaded && thermal.id != null) {
            this.lastMapRgbThermalId = Number(thermal.id);
          } else {
            DotSolarMap.showImageOnMap(false);
            this.lastMapRgbThermalId = null;
            this.showIrOutlineForThermal(thermal);
          }
          return;
        }

        DotSolarMap.removeImageOnMap();
        this.lastMapRgbThermalId = null;
        this.showIrOutlineForThermal(thermal);
      },
      /**
       * 페어링 RGB를 GeoImage 레이어로 올린다.
       * @returns {Promise<boolean>}
       */
      async loadRgbGeoImageOnMap(thermal, imgVisible) {
        if (!thermal?.pairRgbImageId || !thermal?.imgPosCoords) {
          return false;
        }
        try {
          const rgbImg = await SolarRgbImageService.getSolarRgbImage(thermal.pairRgbImageId);
          const hasRgbOwnPos = this.hasImagePositionCoords(rgbImg?.imgPosCoords);
          const rgbGeoForMap = hasRgbOwnPos ? rgbImg.imgPosCoords : thermal.imgPosCoords;
          if (!rgbImg?.imgUrl) {
            DotSolarMap.removeImageOnMap();
            return false;
          }
          if (!this.hasImagePositionCoords(rgbGeoForMap)) {
            DotSolarMap.removeImageOnMap();
            return false;
          }
          const px =
            rgbImg.imgWidth > 0 && rgbImg.imgHeight > 0
              ? { width: rgbImg.imgWidth, height: rgbImg.imgHeight }
              : null;
          const ok = await DotSolarMap.putImageOnMap(
            thermal.imgPosCoords,
            rgbImg.imgUrl,
            rgbGeoForMap,
            imgVisible,
            px,
            { recenterAfterRgb: false }
          );
          return !!ok && DotSolarMap.hasRgbImageOnMap();
        } catch (e) {
          DotSolarMap.removeImageOnMap();
          return false;
        }
      },
      /**
       * 지도 회전값을 설정합니다
       * @param {number} rotation - 회전값 (도 단위)
       */
      setRotation(rotation) {
        if (DotSolarMap.map && DotSolarMap.map.getView()) {
          const rotationInRadians = (rotation * Math.PI) / 180;
          console.log(
            `DotSolarMapBox에서 지도 회전 설정: ${rotation}° (${rotationInRadians} 라디안)`
          );
          DotSolarMap.map.getView().setRotation(rotationInRadians);
        }
      },

      /**
       * RGB Layer 토글 처리
       */
      async toggleRgbLayer() {
        try {
          this.rgbLayerLoading = true;
          this.rgbLayerVisible = !this.rgbLayerVisible;

          if (this.rgbLayerVisible) {
            await this.loadRgbLayer();
          } else {
            this.removeRgbLayer();
          }
        } catch (error) {
          console.error('RGB Layer 토글 중 오류:', error);
          this.rgbLayerVisible = false;
        } finally {
          this.rgbLayerLoading = false;
        }
      },

      /**
       * IR Layer 토글 처리
       */
      async toggleIrLayer() {
        try {
          this.irLayerLoading = true;
          this.irLayerVisible = !this.irLayerVisible;

          if (this.irLayerVisible) {
            await this.loadIrLayer();
          } else {
            this.removeIrLayer();
          }
        } catch (error) {
          console.error('IR Layer 토글 중 오류:', error);
          this.irLayerVisible = false;
        } finally {
          this.irLayerLoading = false;
        }
      },

      /**
       * RGB Layer 로드
       */
      async loadRgbLayer() {
        if (!this.getReportId) {
          console.warn('Report ID가 없어서 RGB Layer를 로드할 수 없습니다.');
          return;
        }

        try {
          console.log('RGB Layer 로드 중...', this.getReportId);
          DotSolarMap.addRgbLayer(this.getReportId);
        } catch (error) {
          console.error('RGB Layer 로드 실패:', error);
          throw error;
        }
      },

      /**
       * IR Layer 로드
       */
      async loadIrLayer() {
        if (!this.getReportId) {
          console.warn('Report ID가 없어서 IR Layer를 로드할 수 없습니다.');
          return;
        }

        try {
          console.log('IR Layer 로드 중...', this.getReportId);
          DotSolarMap.addIrLayer(this.getReportId);
        } catch (error) {
          console.error('IR Layer 로드 실패:', error);
          throw error;
        }
      },

      /**
       * RGB Layer 제거
       */
      removeRgbLayer() {
        console.log('RGB Layer 제거 중...');
        DotSolarMap.removeRgbLayer();
      },

      /**
       * IR Layer 제거
       */
      removeIrLayer() {
        console.log('IR Layer 제거 중...');
        DotSolarMap.removeIrLayer();
      },

      /**
       * GeoJSON 레이어 불러오기 다이얼로그 열기
       */
      openGeoJsonFileDialog() {
        // 기존 GeoJSON 레이어가 있으면 제거
        if (this.geoJsonLayerVisible) {
          this.removeGeoJsonLayer();
          return;
        }

        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '.geojson,.json';
        input.multiple = true; // 여러 파일 선택 가능
        input.onchange = event => {
          const files = Array.from(event.target.files);
          if (files.length > 0) {
            this.loadGeoJsonFiles(files);
          }
        };
        input.click();
      },

      /**
       * GeoJSON 레이어 제거
       */
      removeGeoJsonLayer() {
        DotSolarMap.removeGeoJsonLayer();
        this.geoJsonLayerVisible = false;
        console.log('GeoJSON 레이어가 제거되었습니다.');
      },

      /**
       * 여러 GeoJSON 파일 로드 및 지도에 표시
       */
      loadGeoJsonFiles(files) {
        let loadedCount = 0;
        const totalFiles = files.length;
        const allFeatures = [];

        files.forEach((file, index) => {
          const reader = new FileReader();
          reader.onload = e => {
            try {
              const geojsonData = JSON.parse(e.target.result);
              console.log(`GeoJSON 파일 ${index + 1} 로드됨:`, geojsonData);

              // FeatureCollection인 경우 features 배열 추출
              if (geojsonData.type === 'FeatureCollection' && geojsonData.features) {
                allFeatures.push(...geojsonData.features);
              } else if (geojsonData.type === 'Feature') {
                // 단일 Feature인 경우
                allFeatures.push(geojsonData);
              }

              loadedCount++;

              // 모든 파일이 로드되면 지도에 표시
              if (loadedCount === totalFiles) {
                if (allFeatures.length > 0) {
                  const combinedGeoJson = {
                    type: 'FeatureCollection',
                    features: allFeatures
                  };
                  this.displayGeoJsonOnMap(combinedGeoJson);
                  console.log(`총 ${allFeatures.length}개의 feature가 로드됨`);
                } else {
                  console.warn(
                    'GeoJSON 형식이 아님: type이 FeatureCollection/Feature가 아니거나 표시할 geometry가 없습니다.'
                  );
                  this.notifyMapError(this.$t('map.toastGeoJsonNotFormat'));
                }
              }
            } catch (error) {
              console.error(`GeoJSON 파일 ${index + 1} 파싱 오류:`, error);
              loadedCount++;

              // 모든 파일 처리가 완료되었는지 확인
              if (loadedCount === totalFiles) {
                if (allFeatures.length > 0) {
                  const combinedGeoJson = {
                    type: 'FeatureCollection',
                    features: allFeatures
                  };
                  this.displayGeoJsonOnMap(combinedGeoJson);
                } else {
                  console.warn('GeoJSON 파싱 실패 또는 형식 오류로 표시할 수 없습니다.');
                  this.notifyMapError(this.$t('map.toastGeoJsonReadOrFormatError'));
                }
              }
            }
          };
          reader.readAsText(file);
        });
      },

      /**
       * 단일 GeoJSON 파일 로드 (기존 호환성 유지)
       */
      loadGeoJsonFile(file) {
        this.loadGeoJsonFiles([file]);
      },

      /**
       * GeoJSON 데이터를 지도에 polygon 형태로 표시
       */
      displayGeoJsonOnMap(geojsonData) {
        try {
          // 기존 GeoJSON 레이어 제거
          DotSolarMap.removeGeoJsonLayer();

          // GeoJSON 데이터를 OpenLayers VectorSource로 변환
          const vectorSource = new olSource.Vector({
            features: new olFormat.GeoJSON().readFeatures(geojsonData, {
              dataProjection: 'EPSG:4326', // GeoJSON 데이터의 좌표계
              featureProjection: 'EPSG:4326' // 지도의 좌표계
            })
          });

          // Vector Layer 생성
          const vectorLayer = new olLayer.Vector({
            source: vectorSource,
            style: DotMapStyle.geoJsonFeatureStyle
          });

          // 지도에 레이어 추가
          DotSolarMap.addGeoJsonLayer(vectorLayer);

          // GeoJSON 레이어 상태 활성화
          this.geoJsonLayerVisible = true;

          // 레이어 위치로 지도 이동
          DotSolarMap.fitToGeoJsonLayer(vectorLayer);

          console.log('GeoJSON 레이어가 지도에 추가됨');
          console.log('GeoJSON 파일이 성공적으로 로드되었습니다.');
        } catch (error) {
          console.error('GeoJSON 지도 표시 오류:', error);
          console.error('GeoJSON 파일을 지도에 표시하는데 실패했습니다.');
        }
      },

      // EXIF 분석 수행 메서드
      async performExifAnalysis(files) {
        if (!this.exifAnalyzer) {
          console.log('ExifAnalyzer가 초기화되지 않았습니다.');
          return;
        }

        try {
          console.log('🔍 EXIF 분석을 시작합니다...');

          // 문제가 있는 파일명 (이전 에러에서 확인된 파일)
          const problematicFileName = 'DJI_20250910174510_0050_V.JPG';

          // 파일 비교 분석 수행
          const results = await this.exifAnalyzer.compareFiles(files, problematicFileName);

          console.log('✅ EXIF 분석이 완료되었습니다.');
          console.log('분석 결과:', results);

          // 분석 결과를 전역에서 접근 가능하도록 설정
          window.lastExifAnalysis = results;
        } catch (error) {
          console.error('❌ EXIF 분석 중 오류 발생:', error);
        }
      }
    }
  };
</script>
<style lang="scss">
  /**
  지도의 레이어 순위
  1. 지도 zIndex: 10 (dotsolarmap에 있음)
  2. 지도위의 파란색 선택된 지역 : zIndex:
  3. 지도위의 이미지 : zIndex:
  4. 지도위의 마커 : zIndex:
  5. 지도위의 팝업 : zIndex:
*/
  /* Dashboard 지도: 툴바·열화상 패널 공통 가로 상한 (모바일 전용 분기 없음) */
  $dash-map-overlay-max: 640px;
  /* 툴바(우측 2%) + 열화상(좌측 2%) 동시에 띄울 때 뷰포트 여유 */
  $dash-map-viewport-h-gutter: 80px;
  /* 맵 툴바·열화상 트리거: 뷰포트 해상도로 분기하지 않음(맥 레티나·스케일과 무관하게 동일 밀도) */
  $map-toolbar-btn-w: 46px;
  $map-toolbar-btn-h: 50px;
  /* 왼쪽 툴바 카드 = 그룹 라벨(10px+1px) + 툴바 세로 패딩(3+2) + 타일 */
  $map-toolbar-group-label-stack: 11px;
  $map-toolbar-row-pad-y: 5px;
  $map-toolbar-card-h: $map-toolbar-btn-h + $map-toolbar-group-label-stack + $map-toolbar-row-pad-y;
  $map-toolbar-module-list-btn-w: 64px;
  /* 열화상 미리보기 v-img: 고정 640×512(CSS px) — script THERMAL_IR_PREVIEW_IMG_* 과 동기 */
  $thermal-ir-preview-img-w: 640px;
  $thermal-ir-preview-img-h: 512px;

  /* 열화상 IR 패널: surface·borderSubtle·타이포 정렬 (맵 툴바·Vuetify 테마와 통일) */
  .thermal-ir-panel-card {
    max-width: min($dash-map-overlay-max, calc(100vw - #{$dash-map-viewport-h-gutter}));
    width: 100%;
    box-sizing: border-box;
    border: 1px solid var(--v-borderSubtle-base);
    overflow-x: hidden;
  }

  .thermal-ir-panel-card .thermal-ir-panel-title {
    padding: 10px 12px !important;
    min-height: 0;
    align-items: center !important;
  }

  .thermal-ir-panel-close {
    margin-top: 0;
    margin-right: -4px;
  }

  .thermal-ir-panel-card .thermal-ir-panel-body {
    padding-top: 4px !important;
    padding-left: 8px !important;
    padding-right: 8px !important;
    padding-bottom: 4px !important;
  }

  /* 통계는 본문(px-3) 안 미리보기와 같은 가로 기준 — 옛 v-card-text(pa-2)와 이중 패딩 금지 */
  .thermal-ir-panel-card .thermal-stats-compact.thermal-stats-compact--under-preview {
    padding: 0 !important;
    margin-left: 0;
    margin-right: 0;
    width: 100%;
    box-sizing: border-box;
  }

  .thermal-ir-panel-card .thermal-ir-preview-interactive .mini-img-wrap.v-image {
    width: $thermal-ir-preview-img-w !important;
    max-width: $thermal-ir-preview-img-w !important;
    height: $thermal-ir-preview-img-h !important;
    max-height: $thermal-ir-preview-img-h !important;
    min-height: $thermal-ir-preview-img-h !important;
  }

  .thermal-ir-panel-card .thermal-ir-preview-placeholder-box {
    width: $thermal-ir-preview-img-w;
    max-width: 100%;
    height: $thermal-ir-preview-img-h;
    box-sizing: border-box;
    background-color: var(--v-surfaceDim-base);
    border-radius: 4px;
  }

  .thermal-ir-panel-title {
    align-items: center;
    flex-wrap: nowrap;
  }

  .thermal-ir-panel-title-text {
    min-width: 0;
  }

  /* 패널 본문 안에서는 부모 너비를 넘지 않음(이미지 없을 때 우측 잘림 방지) */
  .thermal-ir-panel-body {
    box-sizing: border-box;
    max-width: 100%;
    min-width: 0;
  }

  .thermal-temp-status-banner {
    max-width: 100%;
    width: 100%;
    box-sizing: border-box;
  }

  /* 온도 미처리 안내: 둥근 모서리 + 옅은 면 + 얕은 그림자 (outlined 테두리와 이중되지 않게 그림자만) */
  .thermal-temp-unavailable-alert {
    font-size: 0.8125rem !important;
    line-height: 1.35 !important;
    word-break: keep-all;
    overflow-wrap: break-word;
    border-radius: 8px !important;
    background-color: color-mix(
      in srgb,
      var(--v-warning-base) 10%,
      var(--v-surface-base)
    ) !important;
    box-shadow: 0 1px 3px color-mix(in srgb, var(--v-text-base) 8%, transparent) !important;
  }

  .theme--dark .thermal-temp-unavailable-alert {
    box-shadow: 0 1px 4px color-mix(in srgb, var(--v-text-base) 18%, transparent) !important;
  }

  .thermal-ir-preview-placeholder-text {
    display: block;
    width: 100%;
    max-width: 100%;
    padding: 0;
    box-sizing: border-box;
    word-break: keep-all;
    overflow-wrap: break-word;
  }

  .thermal-ir-preview-img {
    display: block;
    margin: 0 auto;
  }

  .thermal-ir-preview-interactive {
    position: relative;
  }

  .thermal-hover-readout {
    position: absolute;
    z-index: 2;
    pointer-events: none;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 0.8125rem !important;
    line-height: 1.35;
    background-color: color-mix(in srgb, var(--v-surface-base) 92%, transparent);
    border: 1px solid var(--v-borderSubtle-base);
    color: var(--v-primary-base);
    white-space: nowrap;
  }

  .thermal-stats-compact-row {
    gap: 8px 12px;
    row-gap: 4px;
  }

  .thermal-stats-compact-item {
    font-size: 0.8125rem;
    line-height: 1.35;
  }

  .thermal-stats-compact-value {
    font-size: 0.9375rem;
    line-height: 1.25;
  }

  .map-wrapper {
    width: inherit;
    height: inherit;
  }

  #map {
    height: 100%;
    width: inherit;
    // height: inherit;
  }

  .switch {
    position: fixed;
    top: 0;
    right: 5%;
    z-index: 2;
  }

  .map-right-top-cluster {
    position: absolute;
    top: 20px;
    right: 2%;
    z-index: 100;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 6px;
    /* 맵 컨테이너 기준 — 100vw면 좌측 드로어 무시하고 헤더 메뉴와 겹침 */
    max-width: calc(100% - 4%);
    box-sizing: border-box;
    min-width: 0;
  }

  .map-toolbar {
    position: static;
    right: auto;
    top: auto;
    flex: 1 1 auto;
    min-width: 0;
    background-color: var(--v-surface-base);
    width: auto;
    max-width: 100%;
    box-sizing: border-box;
    /* 좁은 맵: 가로 스크롤로 잘림·헤더 메뉴 가림 방지 */
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
  }

  .map-toolbar::-webkit-scrollbar {
    height: 4px;
  }
  .map-toolbar::-webkit-scrollbar-thumb {
    background: var(--solvit-scrollbar-thumb, #a3a3a3);
    border-radius: 2px;
  }

  /* 툴바:  Intrinsic 너비 유지 + 부모에서만 스크롤 */
  .map-toolbar > .v-card {
    width: max-content;
    max-width: none;
    overflow: visible;
    padding: 0 !important;
  }

  .map-toolbar .v-sheet,
  .map-toolbar .v-toolbar.v-sheet {
    background-color: transparent;
  }

  .map-toolbar .v-btn-toggle:not(.v-btn-toggle--group) {
    background-color: transparent;
  }

  .defect-summary-table.v-data-table {
    background-color: var(--v-surface-base);
    color: var(--v-text-base);
  }

  .defect-type-select.v-select-list {
    background-color: var(--v-surface-base);
  }

  .map-left-overlay-tools {
    position: absolute;
    top: 20px;
    left: 2%;
    z-index: 100;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 6px;
  }

  .map-right-overlay-tools {
    position: static;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    /* 필터 패널로 툴바 높이가 늘어도 모듈 버튼은 상단 유지 */
    align-self: flex-start;
    gap: 6px;
  }

  .map-left-overlay-tools .mini-img,
  .map-right-overlay-tools .mini-img {
    position: static;
    top: auto;
    left: auto;
  }

  .mini-img {
    position: absolute;
    top: 20px;
    left: 2%;
    z-index: 100;
    /*width: 400px;*/
    /*height: 400px;*/
  }

  .defect-summary {
    position: absolute;
    top: 100px;
    right: 2%;
    background-color: transparent;
    z-index: 90;
    width: 275px;
  }

  .defect-summary-card {
    background-color: transparent !important;
  }

  .defect-type-select-box {
    background-color: transparent;
  }

  .defect-sumary-icon {
    max-width: 25px;
  }

  .mini-img-wrap {
    width: 100%;
    max-width: $dash-map-overlay-max;
    height: auto;
    min-height: 0;
    background: var(--v-surface-base);
  }

  /* 결함 윤곽 SVG: 팝업 내부 이미지 위에만 올리고, fixed로 뷰포트를 덮지 않는다.
   (기존 fixed+z-index는 저장/삭제 버튼 클릭을 가로채는 원인이 됨) */
  #ol-popup-img-container {
    position: relative;
    display: inline-block;
    max-width: 433px;
    line-height: 0;
  }

  #ol-popup-canvas {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    pointer-events: none;
    overflow: visible;
  }

  /* IR 결함 박스: 네온(#39ff14) 대신 success 계열 — 팝업 크롬 색감과 덜 충돌 */
  #ol-popup-canvas path {
    stroke: var(--v-success-base, #4ade80);
    stroke-width: 2px;
    fill: none;
    filter: drop-shadow(0 0 1.5px rgba(0, 0, 0, 0.75));
  }

  #ol-popup-img-wrapper {
    padding: 0;
    margin: 0;
    display: block;
  }
  .ol-popup {
    position: absolute;
    min-width: 180px;
    background-color: var(--v-surface-base);
    -webkit-filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.12));
    filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.12));
    /* 상단 4px는 헤더가 눌려 보임 → 헤더는 풀블리드, 본문만 좌우·하단 패딩 */
    padding: 0 16px 16px;
    border-radius: 10px;
    border: 1px solid var(--solvit-border-subtle, var(--v-borderSubtle-base, #e2e8f0));
    bottom: 12px;
    left: -50px;
  }
  .theme--dark .ol-popup {
    -webkit-filter: drop-shadow(0 4px 16px rgba(0, 0, 0, 0.45));
    filter: drop-shadow(0 4px 16px rgba(0, 0, 0, 0.45));
  }
  .ol-popup:after,
  .ol-popup:before {
    top: 100%;
    border: solid transparent;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  .ol-popup:after {
    border-top-color: var(--v-surface-base);
    border-width: 10px;
    left: 48px;
    margin-left: -10px;
  }
  .ol-popup:before {
    border-top-color: var(--solvit-border-subtle, var(--v-borderSubtle-base, #e2e8f0));
    border-width: 11px;
    left: 48px;
    margin-left: -11px;
  }
  /* CrudFormDialogHeader와 맞춤: 여유 패딩 + 하단 구분 + 제목 계층 */
  .ol-popup-header {
    gap: 8px;
    margin: 0 -16px 10px;
    padding: 12px 10px 10px 16px;
    min-height: 48px;
    box-sizing: border-box;
    background-color: var(--v-modalHeader-base, var(--v-surface-base));
    border-bottom: 1px solid var(--v-borderSubtle-base, var(--solvit-border-subtle, #e2e8f0));
    border-radius: 10px 10px 0 0;
  }
  .ol-popup-header__title {
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.35;
    letter-spacing: -0.01em;
    color: var(--v-text-base);
  }
  .ol-popup-closer-btn {
    margin-left: auto;
  }
  .ol-popup-closer-btn .v-icon {
    color: var(--v-text-base) !important;
  }
  .ol-popup-content {
    color: var(--v-text-base);
  }

  .hover mini-img-wrap pa-0 ma-0 {
    background-color: var(--v-surface-base);
  }

  /* 맵 툴바 래스터 아이콘: 라이트 비활성은 MDI와 동일 토큰 --v-mapToolIcon-base(#475569)에 가깝게(순검정 실루엣 제거) */
  .map-toolbar-raster {
    display: block;
    object-fit: contain;
  }
  .v-application.theme--light
    .map-toolbar
    .map-toolbar-raster--light:not(.map-toolbar-raster--active) {
    /* 1) 실루엣 → 2) 슬레이트 블루그레이 근사 (mapToolIcon과 시각 정렬) */
    filter: brightness(0) saturate(100%) invert(33%) sepia(12%) saturate(900%) hue-rotate(176deg)
      brightness(96%) contrast(90%);
    opacity: 1;
  }
  .v-application.theme--light .map-toolbar .map-toolbar-raster--light.map-toolbar-raster--active {
    filter: brightness(0) invert(1);
    opacity: 1;
  }
  /* ON primary/active-dark: 래스터·리포트 SVG도 MDI와 같이 흰색 실루엣 */
  .v-application.theme--dark
    .map-toolbar
    .map-toolbar-interactive-btn.map-toolbar-btn--active-dark
    .map-toolbar-raster,
  .v-application.theme--light
    .map-toolbar
    .map-toolbar-interactive-btn.map-toolbar-btn--on-primary
    .map-toolbar-raster {
    filter: brightness(0) invert(1);
    opacity: 1;
  }
  /* 라이트·보라 배경 토글: MDI·SVG·캡션 흰색 (노란/컬러 래스터 원본 방지) */
  .v-application.theme--light .map-toolbar .map-toolbar-btn--on-primary .v-icon.mdi,
  .v-application.theme--light
    .map-toolbar
    .map-toolbar-btn--on-primary
    .map-toolbar-tool-icon
    .v-icon.mdi,
  .v-application.theme--light .map-left-overlay-tools .map-toolbar-btn--on-primary .v-icon.mdi,
  .v-application.theme--light
    .map-left-overlay-tools
    .map-toolbar-btn--on-primary
    .map-toolbar-tool-icon
    .v-icon.mdi,
  .v-application.theme--light .mini-img.toolbarmap_color .map-toolbar-btn--on-primary .v-icon.mdi,
  .v-application.theme--light
    .mini-img.toolbarmap_color
    .map-toolbar-btn--on-primary
    .map-toolbar-tool-icon
    .v-icon.mdi,
  .v-application.theme--light
    .map-left-overlay-tools
    .v-btn.primary.map-toolbar-btn--on-primary-when-active
    .v-icon.mdi,
  .v-application.theme--light
    .mini-img.toolbarmap_color
    .v-btn.primary.map-toolbar-btn--on-primary-when-active
    .v-icon.mdi {
    color: var(--v-mapToolIconOnPrimary-base) !important;
  }
  .v-application.theme--light
    .map-left-overlay-tools
    .map-toolbar-btn--on-primary
    .map-toolbar-map-marker-svg,
  .v-application.theme--light
    .mini-img.toolbarmap_color
    .map-toolbar-btn--on-primary
    .map-toolbar-map-marker-svg,
  .v-application.theme--light
    .map-toolbar-interactive-btn.map-toolbar-btn--on-primary
    .map-toolbar-report-svg {
    filter: brightness(0) invert(1);
  }
  .map-defect-view-toggle {
    display: inline-flex;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 4px;
    align-items: flex-start;
  }
  .map-defect-view-toggle > .map-toolbar-tool-block {
    margin: 0;
  }
  .map-toolbar-raster--dark {
    filter: none;
  }

  /* 맵 툴바: 아이콘 아래 짧은 캡션(RGB/IR 등)
   Vuetify v-toolbar는 display:block이라 flex-wrap은 .v-toolbar__content에만 먹힌다.
   __content에 인라인 height:64px가 고정돼 있어 줄 바꿈 시 잘리므로 height:auto로 풀고,
   버튼 높이($map-toolbar-btn-h)와 맞춘다. */
  .map-toolbar-toolbar-row {
    width: auto !important;
    max-width: none !important;
    height: auto !important;
    min-height: $map-toolbar-btn-h;
    padding: 0 !important;
  }
  .map-toolbar #toolbar_icon.map-toolbar-toolbar-row {
    overflow: visible;
  }
  .map-toolbar #toolbar_icon.map-toolbar-toolbar-row .v-toolbar__content {
    flex-wrap: nowrap !important;
    flex-shrink: 0;
    width: max-content;
    max-width: none;
    height: auto !important;
    margin: 0 !important;
    /* 그룹 라벨이 상단 테두리에 붙지 않도록 미세 패딩 + 하단과 균형 */
    padding: 3px 4px 2px !important;
    min-height: $map-toolbar-btn-h;
    align-items: center !important;
    align-content: center;
    row-gap: 0;
    column-gap: 0;
    overflow: visible;
  }
  /* 툴바 항목·필터 숫자: 줄어들며 잘리지 않음 (v-toolbar-title ellipsis 회피) */
  .map-toolbar #toolbar_icon .v-toolbar__content > .map-toolbar-group,
  .map-toolbar #toolbar_icon .v-toolbar__content > .map-toolbar-marker-anchor,
  .map-toolbar #toolbar_icon .v-toolbar__content > .map-toolbar-ai-anchor,
  .map-toolbar #toolbar_icon .v-toolbar__content > .map-toolbar-layer-anchor,
  .map-toolbar #toolbar_icon .v-toolbar__content > .map-toolbar-tool-block,
  .map-toolbar #toolbar_icon .v-toolbar__content > .v-divider,
  .map-toolbar #toolbar_icon .v-toolbar__content > .d-flex,
  .map-toolbar #toolbar_icon .v-toolbar__content > .v-menu {
    flex-shrink: 0;
  }
  .map-toolbar-tool-block {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    /* 블록 사이 가로 간격 — 마지막 항목 우측은 아래에서 0으로 둬 툴바 끝 여백 제거 */
    margin: 0 4px 0 0;
    vertical-align: top;
  }

  .map-toolbar-group {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    margin: 0 2px 0 0;
    vertical-align: top;
  }
  .map-toolbar-group-label {
    /* 섹션 힌트: 버튼 캡션보다 한 단계 작게·옅게 (빼지 않고 존재감만 낮춤) */
    font-size: 10px;
    line-height: 1;
    font-weight: 600;
    letter-spacing: 0.04em;
    color: var(--solvit-map-toolbar-idle-fg);
    opacity: 0.65;
    margin: 0 0 1px;
    white-space: nowrap;
    user-select: none;
  }
  .map-toolbar-group-label--spacer {
    visibility: hidden;
    height: 10px;
    margin: 0 0 1px;
  }
  .map-toolbar-group-tools {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
  }
  /* 그룹 라벨 높이만큼 아래로 맞춰 버튼 줄과 정렬 */
  .map-toolbar #toolbar_icon .v-toolbar__content > .v-divider.map-toolbar-divider,
  .map-toolbar #toolbar_icon .v-toolbar__content > .map-toolbar-tool-block {
    align-self: flex-end;
  }
  .map-toolbar #toolbar_icon .v-toolbar__content > .v-divider.map-toolbar-divider {
    height: $map-toolbar-btn-h !important;
    max-height: $map-toolbar-btn-h;
    margin-top: 0;
    margin-bottom: 0;
  }

  .map-toolbar-marker-anchor,
  .map-toolbar-ai-anchor,
  .map-toolbar-layer-anchor {
    position: relative;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    flex-shrink: 0;
    margin: 0;
    vertical-align: top;
  }

  .map-toolbar-group-tools > .map-toolbar-tool-block,
  .map-toolbar-group-tools > .v-menu,
  .map-toolbar-marker-anchor > .map-toolbar-tool-block,
  .map-toolbar-ai-anchor > .map-toolbar-tool-block,
  .map-toolbar-ai-anchor > .v-menu,
  .map-toolbar-layer-anchor > .map-toolbar-tool-block {
    margin-right: 4px;
  }
  .map-toolbar-group-tools > .map-toolbar-tool-block:last-child,
  .map-toolbar-group-tools > .v-menu:last-child .map-toolbar-tool-block,
  .map-toolbar-marker-anchor > .map-toolbar-tool-block:last-child,
  .map-toolbar-ai-anchor > .v-menu:last-child .map-toolbar-tool-block,
  .map-toolbar-ai-anchor > .map-toolbar-tool-block:last-child,
  .map-toolbar-layer-anchor > .map-toolbar-tool-block:last-child {
    margin-right: 0;
  }

  .map-defect-filter-panel {
    position: relative;
    z-index: 5;
  }

  /* 툴바 캡션 밀도에 맞춤 — 라벨이 과하게 크지 않게 */
  .map-defect-filter-combobox ::v-deep .v-label {
    font-size: 0.75rem !important;
    line-height: 1.2;
  }
  .map-defect-filter-combobox ::v-deep .v-label--active {
    font-size: 0.6875rem !important;
  }

  /* 모듈 리스트 열림 — 마커·AI 버튼이 지도에서 숨겨질 때 시각적 안내 */
  .map-toolbar-layer-suppressed {
    opacity: 0.55;
    transition: opacity 0.15s ease;
  }

  .map-toolbar #toolbar_icon .v-toolbar__content > .map-toolbar-tool-block:last-child {
    margin-right: 0;
  }

  /* 왼쪽 열화상 트리거만 있는 래퍼: 우측 마진 불필요 */
  .mini-img.map-toolbar-tool-block {
    margin-right: 0;
  }
  .map-toolbar-status-badge {
    display: inline-flex;
    line-height: 1;
  }
  .map-toolbar-status-badge ::v-deep .v-badge__wrapper {
    display: inline-flex;
  }
  .map-toolbar-status-badge ::v-deep .v-badge__badge {
    font-size: 10px;
    font-weight: 700;
    min-width: 18px;
    height: 18px;
    padding: 0 4px;
    color: #fff !important;
  }
  .map-defect-filter-combobox ::v-deep .v-input__append-inner .v-icon {
    cursor: pointer;
  }
  .map-defect-filter-combobox ::v-deep .v-select__selections .v-chip {
    cursor: pointer;
  }
  .map-toolbar-tool-label {
    font-size: 9px;
    line-height: 1.1;
    font-weight: 500;
    margin: 0 !important;
    padding: 0 !important;
    max-width: $map-toolbar-btn-w;
    text-align: center;
    word-break: break-word;
    box-sizing: border-box;
  }
  /* 맵 툴바 버튼 타일 ($map-toolbar-btn-w × $map-toolbar-btn-h) — 우측 툴바 + 좌측 열화상 미니 동일 */
  .map-toolbar #toolbar_icon .v-btn.map-toolbar-interactive-btn,
  .mini-img.toolbarmap_color .v-btn.map-toolbar-interactive-btn {
    width: $map-toolbar-btn-w !important;
    min-width: $map-toolbar-btn-w !important;
    max-width: $map-toolbar-btn-w !important;
    height: $map-toolbar-btn-h !important;
    min-height: $map-toolbar-btn-h !important;
    max-height: $map-toolbar-btn-h !important;
    padding: 0 !important;
    box-sizing: border-box !important;
  }
  /* MapToolbarTooltipBlock · 좌측 열화상: 버튼 안에 아이콘 + 이름(세로 스택) */
  .map-toolbar .map-toolbar-tool-btn--stack .v-btn__content,
  .mini-img .map-toolbar-tool-btn--stack .v-btn__content {
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 0 !important;
    padding: 0 !important;
    min-height: 0 !important;
    height: 100% !important;
    width: 100% !important;
    box-sizing: border-box !important;
  }
  .map-toolbar .map-toolbar-tool-btn--stack .map-toolbar-tool-label,
  .mini-img .map-toolbar-tool-btn--stack .map-toolbar-tool-label {
    line-height: 1.1;
    max-width: $map-toolbar-btn-w;
    font-size: 9px;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0 !important;
    margin: 0 !important;
    flex-shrink: 0;
    box-sizing: border-box;
  }
  .map-toolbar #toolbar_icon .map-toolbar-tool-btn__inner,
  .mini-img .map-toolbar-tool-btn__inner {
    width: 100%;
    max-width: $map-toolbar-btn-w;
    height: 100%;
    min-height: 0;
    flex: 1 1 auto;
    justify-content: center;
    align-items: center !important;
    padding: 0 !important;
    margin: 0 !important;
    overflow: hidden;
    box-sizing: border-box;
  }
  /* MapToolbarTooltipBlock: captionSpacing — 아이콘·캡션 간격 프리셋 */
  .map-toolbar-tool-btn__inner--gap-tight {
    gap: 0 !important;
  }
  .map-toolbar-tool-btn__inner--gap-tight .map-toolbar-tool-label {
    margin-top: -4px;
  }
  .map-toolbar-tool-btn__inner--gap-default {
    gap: 0 !important;
  }
  .map-toolbar-tool-btn__inner--gap-default .map-toolbar-tool-label {
    margin-top: -1px;
  }
  .map-toolbar-tool-btn__inner--gap-relaxed {
    gap: 0.5px !important;
  }
  .map-toolbar-tool-btn__inner--gap-relaxed .map-toolbar-tool-label {
    margin-top: 0;
  }
  /* RGB 이미지 보기: 래스터와 캡션 사이를 tight보다 살짝만 넓힘 */
  .map-toolbar-tool-btn__inner--gap-rgb-view {
    gap: 0.5px !important;
  }
  .map-toolbar-tool-btn__inner--gap-rgb-view .map-toolbar-tool-label {
    margin-top: -2px;
  }
  /* 맵 툴바·좌측 열화상 미니: 아이콘 영역 */
  .map-toolbar .map-toolbar-tool-icon,
  .mini-img .map-toolbar-tool-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: $map-toolbar-btn-w;
    flex: 1 1 auto;
    min-height: 0;
    box-sizing: border-box;
  }
  .map-toolbar .map-toolbar-tool-icon img,
  .map-toolbar .map-toolbar-tool-icon .map-toolbar-map-marker-svg,
  .map-toolbar .map-toolbar-tool-icon .map-toolbar-report-svg,
  .mini-img .map-toolbar-tool-icon img,
  .mini-img .map-toolbar-tool-icon .map-toolbar-map-marker-svg,
  .mini-img .map-toolbar-tool-icon .map-toolbar-report-svg {
    width: 100% !important;
    height: 100% !important;
    max-width: 100% !important;
    max-height: 100% !important;
    object-fit: contain;
    display: block;
  }
  .map-toolbar .map-toolbar-tool-icon .v-icon.mdi,
  .mini-img .map-toolbar-tool-icon .v-icon.mdi {
    font-size: 20px !important;
    line-height: 1 !important;
  }
  .map-toolbar .map-toolbar-tool-icon .v-icon.mdi-solar-panel {
    font-size: 21px !important;
  }
  /* 캡션 없는 버튼: 아이콘·이미지가 타일 안을 크게 채움 */
  .map-toolbar
    #toolbar_icon
    .v-btn.map-toolbar-interactive-btn:not(.map-toolbar-tool-btn--stack)
    .v-icon.mdi {
    font-size: 24px !important;
    line-height: 1 !important;
  }
  .map-toolbar
    #toolbar_icon
    .v-btn.map-toolbar-interactive-btn:not(.map-toolbar-tool-btn--stack)
    img,
  .map-toolbar
    #toolbar_icon
    .v-btn.map-toolbar-interactive-btn:not(.map-toolbar-tool-btn--stack)
    .map-toolbar-map-marker-svg,
  .map-toolbar
    #toolbar_icon
    .v-btn.map-toolbar-interactive-btn:not(.map-toolbar-tool-btn--stack)
    .map-toolbar-report-svg {
    width: 42px !important;
    height: 42px !important;
    max-width: 100% !important;
    max-height: 100% !important;
    object-fit: contain;
  }
  .mini-img .map-toolbar-tool-btn--stack .map-toolbar-thermal-btn__icon {
    margin: 0 !important;
  }
  .mini-img.toolbarmap_color .map-toolbar-tool-btn--stack.v-btn:not(.v-btn--icon) {
    padding: 0 !important;
  }

  /* 맵 마커·보고서 SVG: 데이터 URL은 object-fit으로 여백 느낀 보조 */
  .map-toolbar-map-marker-svg,
  .map-toolbar-report-svg {
    display: block;
    object-fit: contain;
  }

  .mapmarkClass {
    filter: invert(85%) sepia(13%) saturate(4330%) hue-rotate(195deg) brightness(87%) contrast(96%);
  }
  .v-select__selections input {
    width: 0px;
  }
  .v-autocomplete.v-select.v-input--is-focused input {
    min-width: 0px;
  }
  /* 맵 툴바 안 v-btn-toggle만 직각 — 앱 전역 토글에는 적용하지 않음 */
  .map-toolbar .v-btn-toggle > .v-btn,
  .map-toolbar .v-btn-toggle > .v-btn.v-btn--active {
    border-radius: 0 !important;
  }
  .map-toolbar .v-btn-toggle > .v-btn::before,
  .map-toolbar .v-btn-toggle > .v-btn .v-ripple__container {
    border-radius: 0 !important;
  }

  /* 글자로 된 버튼들(RGB/IR 레이어 small 등): 맵 툴바 스택 제외 시에만 */
  .toolbarmap_color .v-btn:not(.v-btn--icon):not(.map-toolbar-interactive-btn) {
    height: $map-toolbar-btn-h !important;
    min-height: $map-toolbar-btn-h !important;
  }

  /* 툴바 단독 버튼(캡션 없음) 등 tool-icon 밖 mdi — 위 non-stack 규칙과 동일 크기 */
  .map-toolbar #toolbar_icon > .v-scale-transition .v-btn .v-icon.mdi {
    font-size: 24px !important;
  }

  /* 좌·우측 오버레이(열화상·모듈리스트): 열화상 버튼과 동일한 가느다란 흰색(라이트)/밝은(다크) 테두리 */
  .map-left-overlay-tools .map-toolbar-interactive-btn,
  .map-right-overlay-tools .map-toolbar-interactive-btn {
    border: 1px solid var(--solvit-map-toolbar-border) !important;
    box-sizing: border-box !important;
  }

  /* 모듈 리스트 토글만: 왼쪽 툴바 카드 높이에 맞추고, 캡션·테두리로 다른 도구와 구분 */
  .mini-img.toolbarmap_color
    .v-btn.map-toolbar-interactive-btn.map-toolbar-module-list-btn {
    width: $map-toolbar-module-list-btn-w !important;
    min-width: $map-toolbar-module-list-btn-w !important;
    max-width: $map-toolbar-module-list-btn-w !important;
    height: $map-toolbar-card-h !important;
    min-height: $map-toolbar-card-h !important;
    max-height: $map-toolbar-card-h !important;
    border-width: 2px !important;
    border-color: var(--v-primary-base) !important;
  }
  .mini-img
    .map-toolbar-module-list-btn.map-toolbar-tool-btn--stack
    .map-toolbar-tool-label,
  .mini-img .map-toolbar-module-list-btn .map-toolbar-tool-btn__inner,
  .mini-img .map-toolbar-module-list-btn .map-toolbar-tool-icon {
    max-width: $map-toolbar-module-list-btn-w;
  }

  /* 열화상·모듈리스트 등 오버레이 버튼: surface 배경 고정 (비활성만) */
  .map-toolbar-thermal-btn,
  .map-toolbar-module-list-btn.map-toolbar-btn--idle {
    background-color: var(--v-surface-base) !important;
  }

  .map-help-dialog-body {
    line-height: 1.8;
    font-size: 0.8rem;
  }

  .map-help-section-title {
    font-size: 0.85rem;
  }

  .map-help-basic-list {
    list-style: none;
    padding-left: 0;
    margin: 0;
  }

  .map-help-basic-icon {
    flex-shrink: 0;
    margin-right: 8px;
    opacity: 0.85;
  }

  .map-help-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.8rem;
  }

  .map-help-group-heading {
    border-top: 1px solid rgba(128, 128, 128, 0.25);
    padding-top: 8px !important;
    font-weight: 600;
  }
  .map-help-table tr:first-child .map-help-group-heading {
    border-top: none;
    padding-top: 4px !important;
  }

  .map-help-tool-cell {
    padding: 4px 8px 4px 0;
    white-space: nowrap;
    vertical-align: top;
  }

  .map-help-desc-cell {
    padding: 4px 0;
    vertical-align: top;
  }

  .map-help-tool-chip {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    min-width: 44px;
    vertical-align: top;
  }

  .map-help-tool-caption {
    font-size: 0.65rem;
    font-weight: 600;
    line-height: 1.2;
    margin-top: 2px;
    text-align: center;
  }

  .map-help-tool-img {
    display: block;
    object-fit: contain;
  }

  /* 도움말 내 PNG 아이콘: 툴바와 동일 — 라이트는 슬레이트, 다크는 흰색 래스터 */
  .v-application.theme--light
    .map-help-dialog-body
    .map-toolbar-raster--light:not(.map-toolbar-raster--active) {
    filter: brightness(0) saturate(100%) invert(33%) sepia(12%) saturate(900%) hue-rotate(176deg)
      brightness(96%) contrast(90%);
    opacity: 1;
  }

  .map-help-tool-or {
    display: inline-block;
    margin: 0 4px;
    vertical-align: middle;
    font-size: 0.75rem;
    opacity: 0.7;
  }

  .map-help-inline-chip {
    display: inline-flex;
    align-items: center;
    gap: 2px;
    vertical-align: middle;
  }

  .map-help-ordered-list {
    padding-left: 1.2rem;
    margin: 0;
  }

  .map-help-color-swatch {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 2px;
    margin: 0 2px 0 4px;
    vertical-align: middle;
    border: 1px solid rgba(0, 0, 0, 0.15);
  }

  .map-help-color-swatch--ok {
    background: rgba(76, 175, 80, 0.7);
  }

  .map-help-color-swatch--warn {
    background: rgba(255, 193, 7, 0.9);
  }

  .map-help-panels {
    margin-top: 4px;
  }

  .map-help-panels >>> .v-expansion-panel {
    border-top: thin solid rgba(0, 0, 0, 0.08);
  }

  .map-help-panels >>> .v-expansion-panel::before {
    box-shadow: none;
  }

  .map-help-panels >>> .v-expansion-panel-header {
    min-height: 40px;
    padding: 0 4px;
    font-size: 0.85rem;
  }

  .map-help-panel-header-inner {
    display: flex;
    align-items: center;
    min-width: 0;
  }

  .map-help-panel-header-icon {
    flex-shrink: 0;
    margin-right: 8px;
    opacity: 0.85;
  }

  .map-help-panels >>> .v-expansion-panel-content__wrap {
    padding: 0 4px 12px 12px;
  }

  .map-help-panel-content {
    font-size: 0.8rem;
    line-height: 1.75;
  }

  .map-help-filter-note {
    font-size: 0.75rem;
    line-height: 1.5;
    margin: 0;
    opacity: 0.9;
  }

  .map-help-filter-table .map-help-tool-cell {
    vertical-align: middle;
  }

  .map-help-filter-chip {
    height: 22px !important;
    font-size: 11px !important;
    pointer-events: none;
  }

  /* View 모드: bbox 좌상단 — 책갈피 + Module 결함 목록 */
  .map-hierarchy-selection-stack {
    display: flex;
    flex-direction: column-reverse;
    align-items: flex-start;
    pointer-events: none;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.28));
  }

  .map-hierarchy-defect-summary {
    margin-bottom: 4px;
  }

  .map-hierarchy-defect-summary__badge {
    display: inline-block;
    padding: 2px 8px;
    font-size: 10px;
    font-weight: 700;
    line-height: 1.3;
    color: #fff;
    background: rgba(245, 124, 0, 0.95);
    border-radius: 10px;
    white-space: nowrap;
  }

  /* 책갈피 — 위(Array) → 중간(String) → 아래(Module) */
  .map-hierarchy-bookmark-stack {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 3px;
    pointer-events: none;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.28));
  }

  .map-hierarchy-bookmark {
    --bookmark-color: #546e7a;
    position: relative;
    z-index: calc(var(--bookmark-index, 0) + 1);
    margin-top: 0;
    padding: 4px 12px 4px 10px;
    font-size: 11px;
    font-weight: 700;
    line-height: 1.2;
    color: #fff;
    white-space: nowrap;
    background: var(--bookmark-color);
    border-radius: 0 4px 4px 0;
    box-shadow: inset 3px 0 0 rgba(255, 255, 255, 0.35);
  }

  /* column: first-child = 상단(Array), last-child = 하단(Module) */
  .map-hierarchy-bookmark:first-child {
    border-radius: 0 4px 0 0;
    padding-top: 5px;
  }

  .map-hierarchy-bookmark:last-child {
    border-radius: 0 4px 4px 0;
    padding-bottom: 5px;
  }

  .map-hierarchy-bookmark:first-child:last-child {
    border-radius: 0 4px 4px 0;
    padding-top: 4px;
    padding-bottom: 5px;
  }

  .map-hierarchy-bookmark::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    background: rgba(0, 0, 0, 0.18);
    border-radius: 2px 0 0 2px;
  }

  .view-mode-selection-label {
    background: rgba(0, 0, 0, 0.78);
    color: #fff;
    padding: 3px 10px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;
    pointer-events: none;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    letter-spacing: 0.02em;
  }
</style>
